
/*
Author: Vinod
Date: 03/12//2019
Issue Description: image deleting issue
search_string: deleteFile
*/
/*
Author: Siddharth
Date: 03/12/2019
Issue Description: All mandatory fields should be highlighted
search_string: UAT_188
*/
/*
Author: Siddharth
Date: 03/12/2019
Issue Description: IFSC code is not mandatory
search_string: UAT_186
*/
/*
Author: Siddharth
Date: 03/12/2019
Issue Description: Currently Band is mandatory, make it non mandatory
search_string: UAT_175
*/
/*
Author: Siddharth
Date: 30/11/2019
Issue Description: Need option to add other upload options for Personal, Professional, Educational details
search_string: UAT_166
*/
/*
Author: Siddharth
Date: 26/11/2019
Issue Description: Under Disability option should be only Yes / No
search_string: UAT_137
*/

/*
Author: Vinod
Date: 03/12//2019
Issue Description: Change the Text from "Same as Registered Address" to "Same as Permanent Address"
search_string: UAT_174
*/

/*
Author: Vinod
Date: 03/12//2019
Issue Description: Pl remove LWFNumber as there is no LWF number at Employee Level
search_string: UAT_176
*/

/*
Author: Vinod
Date: 03/12//2019
Issue Description: Last name should not be Mandatory
search_string: UAT_187
*/

/*
Author: Vinod
Date: 03/12//2019
Issue Description: If modifications done in the Permanent Address, same should reflect in Communication address if check box is ticked for Same as Permanent Address
search_string: UAT_184
*/

/*
Author: Vinod
Date: 04/12//2019
Issue Description: The disability and Vasectomy field values are going null in request.
search_string: PL_1976
*/

/*
Author: Vinod
Date: 05/12//2019
Issue Description: The employee image not showing while editing the employee.
search_string: PL_2013
*/

/*
Author: Vinod
Date: 05/12//2019
Issue Description: The UAN no is not displaying, while editing an employee.
search_string: PL_2018
*/


/*
Author: Vinod
Date: 05/12//2019
Issue Description: PT deduction frequency not showing while editing an employee.
search_string: PL_2019
*/

/*
Author: Vinod
Date: 05/12//2019
Issue Description: The PT state name is showing different than what it is coming from backend.
search_string: PL_2026
*/

/*
Author: Vinod
Date: 05/12//2019
Issue Description: The fields should be non editable while adding a salary structure to an employee.
search_string: PL_2040
*/
/*
Author: Siddharth
Date: 06/12/2019
Issue Description: Last name should not be Mandatory
search_string: PL-2246
*/
/*
Author: Siddharth
Date: 06/12/2019
Issue Description: Where MICRCode not accepting the Zero at first Place & Alert message reflecting to other MICRCode
search_string: PL-2059
*/

/*
Author: Vinod
Date: 09/12//2019
Issue Description: Under this head only the Fixed Non-CTC Components should be displayed. Currently, even the variable earnings are being displayed
search_string: PL_2241
*/
/*
Author: Siddharth
Date: 19/12/2019
Issue Description: In Add Employee PAN No. is not Mandatory
search_string: PL-2336
*/

/*
Author: Vinod
Date: 11/12/2019
Issue Description: The total amount is coming wrongly in UI.
search_string: PL_2289
*/

/*
Author: Vinod
Date: 16/12/2019
Issue Description: Added a boolean key 'isEdited' for custom input of components values.
search_string: components_isEdited
*/

/*
Author: Vinod
Date: 17/12/2019
Issue Description: minimum_wage_zone_id and industry_type_id issue.
search_string: PL_2314
*/

/*
Author: Vinod
Date: 18/12/2019
Issue Description: Not able to add employees from Run Payroll wizard.
search_string: PL_2318
*/

/*
Author: Vinod
Date: 18/12/2019
Issue Description: The PF settings are not setting according to the PF settings of Legal Entity.
search_string: PL_2320
*/

/*
Author: Vinod
Date: 24/12/2019
Issue Description: While Editing Same as Permanent address check box  is getting checked by default, with different Address.
search_string: checkbox_issue
*/

/*
Author: Vinod
Date: 27/12/2019
Emp Code Impl Description: Employee code auto-generation.
search_string: autogenerate_employee_code
*/

/*
Author: Vinod
Date: 03/01/2020
Emp Code Impl Description: Employee code auto-generation.
search_string: PL_2354
*/

/*
Author: Vinod
Date: 06/01/2020
Emp Code Impl Description: Not able to add employees while PF and ESI are disabled for the employee.
search_string: PL_2355
*/

/*
Author: Vinod
Date: 06/01/2020
Emp Code Impl Description: After uploading employees, it's not redirecting to List of employees table.
search_string: PL_2363
*/

/*
Author: Vinod
Date: 06/01/2020
Emp Code Impl Description: Reporting Manager (Frontend Integration) & Alignment issue.
search_string: PL_2375, PL_2371
*/


/*
Author: Vinod
Date: 06/01/2020
Emp Code Impl Description: unable to get Auto Generate Employee code , After Clicking on Add Employee Button.
search_string: PL_2397
*/

/*
Author: Vinod
Date: 17/01/2020
Issue Description: Please upload the template in AWS and UI.
search_string: PL_2457
*/

/*
Author: Vinod
Date: 23/01/2020
Issue Description: The CTC display needs to be Alligned Properly; Not abble to understand anything
search_string: PL_2507
*/

/*
Author: Vinod
Date: 27/01/2020
Issue Description: While adding an Employee in Previous Employee Details with out giving any data able to see the data.
search_string: PL_2535
*/

/*
Author: Vinod
Date: 27/01/2020
Issue Description: When Clicked on Edit icon by default Communication Address Checked.
search_string: PL_2546
*/

/*
Author: Vinod
Date: 29/01/2020
Issue Description: After changing the old salary structure and deleting few components, still getting them in request.
search_string: PL_2561
*/

/*
Author: Vinod
Date: 04/02/2020
Issue Description: While Updating employee with out PT Applicable, PT State & PT Deduction Frequency going from front end.
search_string: PL_2622
*/

/*
Author: Vinod
Date: 04/03/2020
Issue Description: Future year selection to be disabled.
search_string: PL_2769
*/

/*
Author: Vinod
Date: 05/03/2020
Issue Description: Not able to open PT state fields when check box is ticked
search_string: PL_2669
*/

/*
Author: Vinod
Date: 06/03/2020
Issue Description: In Bank details, Mode of payment "cash" should be selected as default.
search_string: PL_2908
*/

/*
Author: Vinod
Date: 16/03/2020
Enhancement Description: Need to display UDF fields based on Criteria and sub-criteria which are selected in Add Employee.
search_string: PL_2934
*/
/*
Author: Vinod
Date: 16/03/2020
Issue Description: Not able to add Employee, When gender selected as Perfer not to tell
search_string: PL_2941
*/

/*
Author: Vinod
Date: 16/03/2020
Issue Description: If statutory settings are not done, showing the below error message in UI, while adding employee for very first time.
search_string: PL_2943
*/

/*
Author: Shivakumar
Date: 18/03/2020
Issue Description:  DOJ should  not be past date of incorporation date .
search_string: PL_2949
*/

/*
Author: Vinod
Date: 19/03/2020
Issue Description:  Added employee with Bulk upload not able to update the employee getting parameter validation error without editing fields.
search_string: PL_2955
*/

/*
Author: Vinod
Date: 01/04/2020
Issue Description: On selecting different round off scenarios and choosing no round off also, the values are getting rounded off to 1 rupee.
search_string: PL_2358
*/

/*
Author: Vinod
Date: 03/04/2020
Issue Description: The total fixed gross is not showing correctly.
search_string: PL_3014
*/

/*
Author: Vinod
Date: 03/04/2020
Issue Description: The reporting manager is not showing in list when there are thousands of employees..
search_string: PL_3023
*/

/*
Author: Vinod
Date: 16/04/2020
Issue Description: Mode of Payment is transfer, In Another Bank Account Details and same Account for FBP? Star mark is missing.
search_string: PL_3067
*/

<template>
  <div class="main-div">
    <div>
      <div class="top-bar" v-show="showTopBar">
        <img @click="goBackToDashboardPage" src="@/assets/path-2-copy.png" />
        <span
          class="heading_new"
        >{{$route.query.id ? `Edit Employee - ${personal.name}` : 'Add Employee'}}</span>
      </div>
      <div :class="{ 'main-container': showTopBar }">
        <div class="addflexiwithspace" v-if="!($route.query.id)">
          <tl-radio
            name="uploadMethod"
            label="Bulk Upload"
            id="bulkUpload"
            value="bulkUpload"
            v-model="uploadMethod"
          />
          <tl-radio
            name="uploadMethod"
            label="Manual"
            id="manualUpload"
            value="manualUpload"
            v-model="uploadMethod"
          />
        </div>
        <toast-message
          :message="errmsg"
          type="error"
          :isToastEnable="toast"
          @close="(val) => toast = val"
        />

        <div class="bulkUploadClass margin-l-l" v-if="uploadMethod == 'bulkUpload'">
          <div class="download-btn marginbot-20">
            <!-- PL_2457 -->
           <download-button @downloadTemplate="getEmployeeTemplate()"
            ></download-button>
          </div>
          <div :key="componentKey">
            <upload-file :apiUrl="bulkUploadUrl" :params="{loggedInUser : loginId}" @uploadTemplate="onUploadTemplate($event);onUploadTemplateFailed($event)" />
          </div>
        </div>

        <div v-if="uploadMethod == 'manualUpload'">
          <tl-accordion headerName="Personal Information" :active="true">
            <div slot="accordionBody">
              <div class="row">
                <div class="col-12 margin-b-m">
                  <span class="input-label">Upload Photo</span>
                </div>
                <div class="col-12">
                  <!-- start deleteFile -->
                  <!-- Start PL_2013 -->
                  <upload-image
                    class="margintop-8"
                    :logo="personal.photo_url"
                    @change="(val)=>personal.photo_url=val.data.location"
                    @deleteFile="personal.photo_url= ''"
                    @editImage="(val) => personal.photo_url = val.data.location"
                    uploadBtnText="Upload Photo"
                  ></upload-image>
                  <!-- End PL_2013 -->
                  <!-- end deleteFile -->
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-3 margin-t-s">
                  <!-- PL_2397 -->
                  <txt
                    label="Employee Code*"
                    type="text"
                    name="code"
                    data-vv-as="code"
                    v-model="personal.code"
                    v-validate="{required:true}"
                    :classname="errors.has('code')"
                    :errormsg="errors.first('code')"
                  ></txt>
                </div>
                <div class="radio-container col-6 margin-t-s mt-2 mb-0">
                  <div>Gender</div>
                  <div class="radio-btn">
                    <tl-radio
                      name="gender"
                      label="Male"
                      id="gender1"
                      value="male"
                      v-model="personal.gender"
                    />
                    <tl-radio
                      name="gender"
                      label="Female"
                      id="gender2"
                      value="female"
                      v-model="personal.gender"
                    />
                    <tl-radio
                      name="gender"
                      label="Other"
                      id="gender3"
                      value="other"
                      v-model="personal.gender"
                    />
                    <!-- PL_2941 -->
                    <tl-radio
                      name="gender"
                      label="Prefer not to tell"
                      id="gender4"
                      value="undisclosed"
                      v-model="personal.gender"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4 margin-t-s">
                  <txt
                    label="First Name*"
                    type="text"
                    name="first_name"
                    v-model="personal.first_name"
                    data-vv-as="first name"
                    v-validate="{required: true, alpha_spaces:true}"
                    :classname="errors.has('first_name')"
                    :errormsg="errors.first('first_name')"
                  ></txt>
                </div>
                <!-- start UAT_187 -->
                <div class="col-4 margin-t-s">
                  <txt label="Last Name" type="text" name="last_name" v-model="personal.last_name"></txt>
                  <!-- end UAT_187 -->
                </div>
                <div class="col-4 margin-t-s">
                  <txt label="User Name" type="text" name="username" v-model="personal.username"></txt>
                </div>
                <div class="col-4 margin-t-s">
                  <txt
                    label="Father Name"
                    type="text"
                    name="father_name"
                    v-model="personal.father_name"
                  ></txt>
                </div>
                <div class="col-4 margin-t-s">
                  <txt
                    label="Mother Name"
                    type="text"
                    name="mother_name"
                    v-model="personal.mother_name"
                  ></txt>
                </div>
                <div class="col-4 margin-t-s">
                  <span class="input-label">Date of Birth*</span>
                  <date-picker
                    name="dob"
                    data-vv-name="dob"
                    :value="personal.dob"
                    data-vv-as="date of birth"
                    @datevalue="(val)=>personal.dob=val"
                    v-validate="{required: true}"
                    :dates-disabled="{from: new Date(new Date().setYear(new Date().getFullYear()-18))}"
                    :openDate="new Date(new Date().setYear(new Date().getFullYear()-18))"
                    :classname="errors.has('dob')"
                    :errormsg="errors.first('dob')"
                  />
                </div>
                <div class="col-4 margin-t-s">
                  <tl-select
                    label="Marital Status"
                    name="marital_status"
                    data-vv-as="marital status"
                    labelText="name"
                    :options="maritalStatus"
                    v-model="personal.marital_status"
                    @change="(val)=>{marital_status=val;personal.marital_status=val? val.id:null}"
                  ></tl-select>
                </div>
                <div class="col-4 margin-t-s">
                  <txt
                    label="Personal Mobile Number"
                    type="text"
                    name="mobile_number"
                    v-numeric-only
                    data-vv-as="mobile number"
                    v-model="personal.mobile_number"
                  ></txt>
                </div>
                <div class="col-4 margin-t-s">
                  <txt
                    label="Personal Email Id"
                    type="email"
                    name="personalEmail"
                    data-vv-as="personal email"
                    v-model="personal.email_id"
                    v-validate="{regex: emailRegex, max:100}"
                    :classname="errors.has('personalEmail')"
                    :errormsg="errors.first('personalEmail')"
                  ></txt>
                </div>

                <div class="col-4 margin-t-s">
                  <txt
                    label="Phone No."
                    type="text"
                    v-numeric-only
                    name="phone_number"
                    data-vv-as="phone number"
                    v-model="personal.phoneNumber"
                    v-validate="{required: false,regex: phoneNumRegex}"
                  ></txt>
                </div>
                <!-- UAT 139 (Emergency Contact name & Number should be together) - 29/11/2019 -->
                <div class="col-4 margin-t-s">
                  <txt
                    label="Emergency Contact Name"
                    type="text"
                    name="emergency_contact_name"
                    data-vv-as="emergency contact name"
                    v-model="personal.emergency_contact_name"
                    v-validate="{alpha_spaces:true}"
                    :classname="errors.has('emergency_contact_name')"
                    :errormsg="errors.first('emergency_contact_name')"
                  ></txt>
                </div>
                <div class="col-4 margin-t-s">
                  <txt
                    label="Emergency Contact No."
                    type="text"
                    name="emergency_contact_number"
                    v-numeric-only
                    data-vv-as="emergency contact number"
                    v-model="personal.emergency_contact_number"
                  ></txt>
                </div>
                <div class="col-4 margin-t-s">
                  <txt
                    label="Permanent Retirement Account Number"
                    type="text"
                    maxlength="12"
                    name="pran_number"
                    v-numeric-only
                    data-vv-as="permanent retirement account number"
                    v-model="personal.pran_number"
                    v-validate="{length:12}"
                    :classname="errors.has('pran_number')"
                    :errormsg="errors.first('pran_number')"
                  ></txt>
                </div>

                <div class="col-4 margin-t-s">
                  <txt
                    label="PAN"
                    type="text"
                    name="pan_number"
                    v-model="personal.pan_number"
                    data-vv-as="PAN number"
                    @change="(val)=> personal.pan_number = val.toUpperCase()"
                    v-validate="{required:false, length:10, regex:pancardRegex}"
                    :classname="errors.has('pan_number')"
                    :errormsg="errors.first('pan_number')"
                  ></txt>
                </div>
                <!--  data-vv-as="PAN number"
                    v-validate="{required:true,length:10, regex:/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/}"
                    :classname="errors.has('pan_number')"
                    :errormsg="errors.first('pan_number')"
                -->
                <div class="col-4 margin-t-s">
                  <txt
                    label="Aadhar No."
                    type="text"
                    name="adhar_number"
                    maxlength="12"
                    data-vv-as="adhar number"
                    v-numeric-only
                    v-model="personal.adhar_number"
                    v-validate="{length:12}"
                    :classname="errors.has('adhar_number')"
                    :errormsg="errors.first('adhar_number')"
                  ></txt>
                </div>
              </div>
              <div class="row">
                <div class="radio-container col-4">
                  <div class="margin-t-s">Tax Status</div>
                  <div class="radio-btn">
                    <tl-radio
                      name="tax"
                      label="Resident"
                      id="tax1"
                      value="resident"
                      v-model="personal.employee_tax_status"
                    />
                    <tl-radio
                      name="tax"
                      label="Non-resident"
                      id="tax2"
                      value="nri"
                      v-model="personal.employee_tax_status"
                    />
                  </div>
                </div>
                <div class="radio-container col-4">
                  <div class="margin-t-s">Metro</div>
                  <div class="radio-btn">
                    <tl-radio
                      name="metro"
                      label="Yes"
                      id="metro1"
                      :value="true"
                      v-model="personal.metro"
                      @change="()=>personal.metro=true"
                    />
                    <tl-radio
                      name="metro"
                      label="No"
                      id="metro2"
                      :value="false"
                      v-model="personal.metro"
                      @change="()=>personal.metro=false"
                    />
                  </div>
                </div>
              </div>
              <div class="header header2">
                <span class="text">Permanent Address</span>
              </div>
              <div class="row">
                <div class="col-6">
                  <txt
                    label="Address Line 1"
                    name="address_line_one"
                    data-vv-as="Address"
                    type="text"
                    v-model="personal.permanent_address.addressLineOne"
                    @change="(val)=>{personal.permanent_address.addressLineOne=val.trim()}"
                    v-validate="{required: false}"
                    :classname="errors.has('address_line_one')"
                    :errormsg="errors.first('address_line_one')"
                  ></txt>
                </div>
                <div class="col-6">
                  <txt
                    label="Address Line 2"
                    name="address_line_two"
                    data-vv-as="address line two"
                    type="text"
                    v-model="personal.permanent_address.addressLineTwo"
                    @change="(val)=>{personal.permanent_address.addressLineTwo=val.trim()}"
                    v-validate="{required: false}"
                    :classname="errors.has('address_line_two')"
                    :errormsg="errors.first('address_line_two')"
                  ></txt>
                </div>
                <div class="col-6 margintop-20">
                  <tl-select
                    class="customwidth"
                    :label="`State / Union Territory ${(personal.permanent_address.addressLineOne || personal.permanent_address.addressLineTwo) ? '*' : ''}`"
                    name="state"
                    labelText="state_name"
                    data-vv-as="state / union territory"
                    :options="state"
                    v-model="state_id"
                    @change="(val)=>{state_id=val; city_id=''; personal.permanent_address.stateID = val? val.id:null; personal.permanent_address.stateName = val? val.state_name:null; personal.communication_address.isSameAsPermanent? this.comStateID = val: '';}"
                    v-validate="{required: (personal.permanent_address.addressLineOne || personal.permanent_address.addressLineTwo) ? true : false}"
                    :classname="errors.has('state')"
                    :errormsg="errors.first('state')"
                  ></tl-select>
                </div>
                <div class="col-6 margintop-20">
                  <tl-select
                    class="customwidth"
                    :label="`City ${(personal.permanent_address.addressLineOne || personal.permanent_address.addressLineTwo) ? '*' : ''}`"
                    :disabled="!(state_id && state_id.City  ? state_id.City.length: true)"
                    name="city"
                    labelText="city_name"
                    data-vv-as="city"
                    :options="state_id ? state_id.City : []"
                    v-model="city_id"
                    @change="(val)=>{city_id=val; personal.permanent_address.cityID = val? val.id:null;personal.permanent_address.cityName = val? val.city_name:null; personal.communication_address.isSameAsPermanent ? this.comCityID=val :'';}"
                    v-validate="{required: ((state_id && state_id.City) && (personal.permanent_address.addressLineOne || personal.permanent_address.addressLineTwo)) ? true :false}"
                    :classname="errors.has('city')"
                    :errormsg="errors.first('city')"
                  ></tl-select>
                </div>
                <div class="col-6 margintop-20">
                  <tl-select
                    class="customwidth"
                    label="Country"
                    name="country"
                    labelText="name"
                    :disable="true"
                    :options="countriesListArray"
                    v-model="country_id"
                    @change="(val)=>{country_id=val; personal.permanent_address.countryID=val.id;}"
                  ></tl-select>
                </div>

                <div class="col-6 margintop-20">
                  <txt
                    :label="`Pincode ${(personal.permanent_address.addressLineOne || personal.permanent_address.addressLineTwo) ? '*' : ''}`"
                    type="text"
                    name="pin_code"
                    data-vv-as="pin code"
                    maxlength="6"
                    v-numeric-only
                    v-model="personal.permanent_address.pincode"
                    v-validate="{required:(personal.permanent_address.addressLineOne || personal.permanent_address.addressLineTwo) ? true : false,length:6, regex:pincodeRegex}"
                    :classname="errors.has('pin_code')"
                    :errormsg="errors.first('pin_code')"
                  ></txt>
                </div>
                <div class="col-6 margintop-20">
                  <txt
                    label="Email Id"
                    type="email"
                    name="email"
                    data-vv-as="permanent email"
                    v-model="personal.permanent_address.email"
                    v-validate="{regex: emailRegex, max:100}"
                    :classname="errors.has('email')"
                    :errormsg="errors.first('email')"
                  ></txt>
                </div>

                <div class="col-6 margintop-20">
                  <txt
                    label="Phone No."
                    name="phonenumber"
                    type="text"
                    v-numeric-only
                    data-vv-as="phone number"
                    v-model="personal.permanent_address.phoneNumber"
                    v-validate="{required: false,regex: phoneNumRegex}"
                  ></txt>
                </div>
              </div>
              <div class="header header2">
                <span class="text">Communication Address</span>
              </div>
              <div class="row">
                <!-- start UAT_174, PL_2546 -->
                <div class="col-12">
                  <tl-checkbox
                    class="headcheck"
                    name="headsameAsReg"
                    label="Same as Permanent Address"
                    v-model="personal.communication_address.isSameAsPermanent"
                    @change="(val)=>mapAddress(val)"
                  />
                </div>
                <!-- end UAT_174 -->
                <div class="col-6 margintop-10">
                  <txt
                    label="Address Line 1"
                    type="text"
                    name="headOfficeAddressLineOne"
                    data-vv-as="address"
                    :disable=communicationAddressDisable
                    v-model="personal.communication_address.addressLineOne"
                  ></txt>
                  <!--
                    v-validate="{required: true}"
                    :classname="errors.has('headOfficeAddressLineOne')"
                    :errormsg="errors.first('headOfficeAddressLineOne')"
                  -->
                </div>
                <div class="col-6 margintop-10">
                  <txt
                    label="Address Line 2"
                    type="text"
                    name="headOfficeAddressLineTwo"
                    v-model="personal.communication_address.addressLineTwo"
                    :disable=communicationAddressDisable
                  ></txt>
                </div>
                <div class="col-6 margintop-20">
                  <tl-select
                    class="customwidth"
                    label="State / Union Territory"
                    labelText="state_name"
                    name="headOfficeState"
                    :options="state"
                    v-model="comStateID"
                    :disable=communicationAddressDisable
                    @change="(val)=>{comStateID=val; comCityID=''; personal.communication_address.stateID = val? val.id:null; personal.communication_address.stateName = val? val.state_name:null}"
                  />
                </div>
                <div class="col-6 margintop-20">
                  <tl-select
                    class="customwidth"
                    label="City"
                    labelText="city_name"
                    name="headOfficeCity"
                    :options="comStateID ? comStateID.City:[]"
                    v-model="comCityID"
                    :disable=communicationAddressDisable
                    @change="(val)=>{comCityID=val; personal.communication_address.cityID = val? val.id:null; personal.communication_address.cityName = val? val.city_name:null}"
                  ></tl-select>
                </div>

                <div class="col-6 margintop-20">
                  <tl-select
                    class="customwidth"
                    label="Country"
                    labelText="name"
                    name="headOfficeCountry"
                    data-vv-as="country"
                    :disable="true"
                    :options="countriesListArray"
                    v-model="comCountryID"
                    @change="(val)=>{comCountryID=val; personal.communication_address.countryID=val? val.id:null;}"
                  ></tl-select>
                </div>
                <div class="col-6 margintop-20">
                  <txt
                    label="Pincode"
                    type="text"
                    name="com_pin_code"
                    data-vv-as="pin code"
                    maxlength="6"
                    v-numeric-only
                    v-model="personal.communication_address.pincode"
                    v-validate="{length:6, regex:pincodeRegex}"
                    :disable=communicationAddressDisable
                    :classname="errors.has('com_pin_code')"
                    :errormsg="errors.first('com_pin_code')"
                  ></txt>
                </div>

                <div class="col-6 margintop-20">
                  <txt
                    label="Email Id"
                    type="email"
                    name="communicationEmail"
                    data-vv-as="communication email"
                    v-model="personal.communication_address.email"
                    v-validate="{regex: emailRegex, max:100}"
                    :classname="errors.has('communicationEmail')"
                    :errormsg="errors.first('communicationEmail')"
                  ></txt>
                </div>

                <div class="col-6 margintop-20">
                  <txt
                    label="Phone No."
                    name="commphone_number"
                    type="text"
                    v-numeric-only
                    data-vv-as="phone number"
                    :disable=communicationAddressDisable
                    v-model="personal.communication_address.phoneNumber"
                    v-validate="{required: false,regex: phoneNumRegex}"
                  ></txt>
                </div>
              </div>
            </div>
          </tl-accordion>
          <tl-accordion headerName="Official Information" :active="true">
            <div slot="accordionBody">
              <div class="row">
                <div class="col-4 margintop-20">
                  <span class="input-label">Date of Joining*</span>
                  <!-- UAT 142(PF Enrolment date should be by default date of joining with option to change it to future date but not date before date of joining) - 29/11/2019 -->
                  <date-picker
                    name="date_of_joining"
                    :value="official.date_of_joining"
                    @datevalue="(val)=>{official.date_of_joining=val; pfesi.pf_enrollment_date = val;}"
                    v-validate="{required: true}"
                    data-vv-as="date of joining"
                    :dates-disabled="{to:new Date(leIncorporationDate)}"
                    :classname="errors.has('date_of_joining')"
                    :errormsg="errors.first('date_of_joining')"
                  ></date-picker>
                </div>
                <div class="col-4 margintop-20">
                  <txt
                    label="Official Email Id"
                    name="official_email_id"
                    type="email"
                    v-model="official.official_email_id"
                    data-vv-as="official email"
                    v-validate="{required: false,regex: emailRegex, max:100}"
                    :classname="errors.has('official_email_id')"
                    :errormsg="errors.first('official_email_id')"
                  ></txt>
                </div>
                <div class="col-4 margintop-20">
                  <tl-select
                    label="Skill Type"
                    name="skill"
                    labelText="name"
                    :options="skillList"
                    v-model="skill"
                    @change="(val)=>{skill=val;official.skill=val? val.id:null}"
                  ></tl-select>
                </div>
                <div class="col-4 margintop-20">
                  <tl-select
                    label="Location*"
                    labelText="name"
                    :placeholder="'Select'"
                    name="based_location_id"
                    :options="locationList"
                    v-model="location_id"
                    data-vv-as="location"
                    @change="(val)=>{location_id = val;official.based_location_id=val? val.id:null;official.based_location_name = val ? val.name : null; setLWF_PT_ESI_MWZ(); filterUdf('Location',val);}"
                    v-validate="{required: true}"
                    :classname="errors.has('based_location_id')"
                    :errormsg="errors.first('based_location_id')"
                  ></tl-select>
                </div>
                <div class="col-4 margintop-20">
                  <tl-select
                    label="Employee Category"
                    labelText="name"
                    name="category_data_json"
                    :options="categoryList"
                    v-model="official.category_data_json"
                    @change="(val)=>{categoryChange(val); official.category_id = val? val.id:null; filterUdf('Employee Categories & Sub Categories', val)}"
                  ></tl-select>
                  <!-- @change="(val)=>{official.category_data_json=val}" -->
                </div>
                <div class="col-4 margintop-20">
                  <tl-select
                    label="Employee Sub Category"
                    :placeholder="'Select'"
                    labelText="name"
                    name="employee_sub_category"
                    :options="employeesubcategoryList"
                    v-model="employeesubcategoryList_id"
                    @change="(val)=>{employeesubcategoryList_id = val;official.subcategory=val? val.id:null}"
                  ></tl-select>
                </div>
                <div class="col-4 margintop-20">
                  <tl-select
                    label="Department"
                    labelText="name"
                    name="department"
                    :options="departmentList"
                    v-model="department_id"
                    @change="(val) => {department_id=val;official.department_id = val? val.id:null; official.department_name = val ? val.name : null; filterUdf('Department',val);}"
                  ></tl-select>
                </div>

                <div class="col-4 margintop-20">
                  <tl-select
                    label="Cost Centre"
                    labelText="name"
                    name="cost_center_id"
                    :options="costCenterList"
                    v-model="cost_center_id"
                    @change="(val) => {cost_center_id = val;official.cost_center_id = val? val.id:null; official.cost_center_name = val ? val.name : null; filterUdf('Cost Centre',val);}"
                  ></tl-select>
                </div>
                <div class="col-4 margintop-20">
                  <tl-select
                    :disabled=false
                    label="Pay Group"
                    labelText="name"
                    name="paygroup_id"
                    :options="paygroupList"
                    v-model="paygroup_id"
                    data-vv-as="paygroup"
                    @change="(val)=>{paygroup_id = val;official.paygroup_id=val? val.id:null; official.paygroup_name = val ? val.name : null;}"
                    v-validate="{required: false}"
                    :classname="errors.has('paygroup_id')"
                    :errormsg="errors.first('paygroup_id')"
                  ></tl-select>
                </div>
                <div class="col-4 margintop-20">
                  <tl-select
                    label="Grade"
                    :options="gradeList"
                    labelText="name"
                    name="grade_id"
                    v-model="grade_id"
                    @change="(val) => {grade_id = val; official.grade_id = val? val.id:null;official.grade_name = val ? val.name : null; filterUdf('Grade',val);}"
                  ></tl-select>
                </div>
                <!-- start UAT_175 -->
                <div class="col-4 margintop-20">
                  <tl-select
                    label="Band"
                    labelText="name"
                    name="band_id"
                    :options="bandList"
                    v-model="band_id"
                    @change="(val) => {band_id = val; official.band_id = val? val.id:null; official.band_name = val ? val.name : null; filterUdf('Salary Band',val);}"
                  ></tl-select>
                </div>
                <!-- End UAT_175 -->
                <div class="col-4 margintop-20">
                  <tl-select
                    label="Designation"
                    labelText="name"
                    name="designation_id"
                    :options="designationList"
                    v-model="designation_id"
                    @change="(val) => {designation_id = val;official.designation_id = val? val.id:null ;official.designation_name = val ? val.name : null;}"
                    data-vv-as="designation"
                    v-validate="{required: false}"
                    :classname="errors.has('designation_id')"
                    :errormsg="errors.first('designation_id')"
                  ></tl-select>
                </div>
                <div class="col-4 margintop-20">
                  <tl-select
                    label="Level"
                    labelText="name"
                    name="level_id"
                    :options="levelList"
                    v-model="level_id"
                    @change="(val) => {level_id = val;official.level_id = val? val.id:null; ;official.level_name = val ? val.name : null;}"
                    data-vv-as="level"
                    v-validate="{required: false}"
                    :classname="errors.has('level_id')"
                    :errormsg="errors.first('level_id')"
                  ></tl-select>
                </div>
                <!-- issue while adding employee - PL-1936  - 29/11/2019 -->
                <div class="col-4 margintop-20">
                  <tl-select
                    label="Disability"
                    name="disability"
                    labelText="name"
                    :options="disabilitySelection"
                    v-model="disability"
                    @change="(val) => {disability=val;official.disability = val? val.value:null;}"
                  ></tl-select>
                </div>
                <!-- issue while adding employee - PL-1936  - 29/11/2019 -->
                <div class="col-4 margintop-20">
                  <tl-select
                    label="Vasectomy"
                    name="vasectomy"
                    :options="vasectomySelection"
                    v-model="vasectomy"
                    @change="(val) => {vasectomy= val;official.vasectomy = (val == 'Yes')? true : false}"
                  ></tl-select>
                </div>

                <div class="radio-container col-4 margintop-20">
                  <div class="margin-t-s">Is Reporting Manager</div>
                  <div class="radio-btn">
                    <tl-radio
                      name="rm"
                      label="No"
                      id="rm1"
                      :value="false"
                      v-model="official.is_reporting_manager"
                      @change="()=>official.is_reporting_manager=false"
                    />
                    <tl-radio
                      name="rm"
                      label="Yes"
                      id="rm2"
                      :value="true"
                      v-model="official.is_reporting_manager"
                      @change="()=>official.is_reporting_manager=true"
                    />
                  </div>
                </div>

                <div class="col-4 margintop-20">
                  <label class="input-label margin-b-n">Reporting Manager</label>
                  <search-dropdown
                    class="search"
                    :placeholder="'Reporting Manager'"
                    :selectedEmp="managerName"
                    :employeeData="customEmpList"
                    ref="search"
                    @getList="getEmployeesByName($event)"
                    @empselected="(val)=>empselected(val)"
                    @clear="(val) =>{clearEmployee()}"
                  />
                </div>
                   <div class="col-4 margintop-20">
                  <tl-select
                    label="Employment Type"
                    name="employment_type"
                    labelText="name"
                    :options="employment_types"
                    v-model="employment_type"
                    @change="(val) => {e=val;official.employment_type = val? val.value:null;}"
                  ></tl-select>
                </div>
                <!-- <div class="radio-container col-4">
                  <div class="margin-t-s">Has ESS</div>
                  <div class="radio-btn">
                    <tl-radio
                      name="hasEss"
                      label="No"
                      id="hasEss2"
                      :value="false"
                      v-model="personal.is_ess_enable"
                      @change="()=>personal.is_ess_enable=false"
                    />
                    <tl-radio
                      name="hasEss"
                      label="Yes"
                      id="hasEss1"
                      :value="true"
                      v-model="personal.is_ess_enable"
                      @change="()=>personal.is_ess_enable=true"
                    />
                  </div>
                </div> -->
              </div>
            </div>
          </tl-accordion>

          <tl-accordion headerName="Previous Employers Details">
            <div slot="accordionBody">
              <div class="row">
                <span class="heading">Gratuity Details</span>
              </div>
              <div class="row margin-t-s" v-for="(slab,index) in gratuity_details" :key="index+'k'">
                <div class="col-3">
                  <span class="input-label">Select Financial Year</span>
                  <date-picker
                    class="customwidth"
                    :formatDate="'yyyy'"
                    placeholder="Select Year"
                    :minimumView="'year'"
                    v-model="slab.slabFinancialYear"
                    :datesDisabled="{from:new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())}"
                    @datevalue="(val)=>{slab.slabFinancialYear=val}"
                  />
                </div>
                <div class="col-3">
                  <txt
                    label="Company Name"
                    :name="'slabCompanyName'+index"
                    type="text"
                    v-model="slab.slabCompanyName"
                  ></txt>
                </div>
                <div class="col-3">
                  <txt
                    label="Amount"
                    v-numeric-only
                    :name="'slabAmount'+index"
                    type="number"
                    v-model="slab.slabAmount"
                    v-maxchars="9"
                    v-validate="{max: 9}"
                    data-vv-as="amount"
                    :classname="errors.has('slabAmount'+index)"
                    :errormsg="errors.first('slabAmount'+index)"
                  ></txt>
                </div>
                <div class="col-3 deleteButton" v-if="gratuity_details.length > 1">
                  <span class="row-container action-img delecteIcon">
                    <img src="@/assets/delete.svg" @click="deleteGratuity(index)" alt="delete" />
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <a
                    href="javascript:void(0)"
                    class="add-new margin-tb-s"
                    @click="addGratuityObj()"
                  >Add New</a>
                </div>
              </div>
              <div class="row">
                <span class="heading">Leave Encashment</span>
              </div>
              <div class="row margin-t-s" v-for="(leave,idx) in leave_encashment" :key="idx+'j'">
                <div class="col-3">
                  <span class="input-label">Select Financial Year</span>
                  <date-picker
                    class="customwidth"
                    :formatDate="'yyyy'"
                    placeholder="Select Year"
                    :minimumView="'year'"
                    v-model="leave.leaveFinancialYear"
                    :datesDisabled="{from:new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())}"
                    @datevalue="(val)=>{leave.leaveFinancialYear= val}"
                  />
                </div>
                <div class="col-3">
                  <txt
                    label="Company Name"
                    :name="'leaveCompanyName'+idx"
                    type="text"
                    v-model="leave.leaveCompanyName"
                  ></txt>
                </div>
                <div class="col-3">
                  <txt
                    label="Amount"
                    :name="'leaveAmount'+idx"
                    v-numeric-only
                    type="number"
                    v-model="leave.leaveAmount"
                    v-maxchars="9"
                    data-vv-as="amount"
                    v-validate="{max: 9}"
                    :classname="errors.has('leaveAmount'+idx)"
                    :errormsg="errors.first('leaveAmount'+idx)"
                  ></txt>
                </div>
                <div class="col-3 deleteButton" v-if="leave_encashment.length >1">
                  <span class="row-container action-img delecteIcon">
                    <img src="@/assets/delete.svg" @click="deleteLeaveEnc(idx)" alt />
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <a
                    href="javascript:void(0)"
                    class="add-new margin-tb-s"
                    @click="leaveEncashment()"
                  >Add New</a>
                </div>
              </div>
              <div class="row">
                <span class="heading">LTA Details</span>
              </div>
              <div class="row margin-t-s" v-for="(lta,index) in lta_details" :key="index+'i'">
                <div class="col-3">
                  <tl-select
                    class="customwidth"
                    label="Select Block Year"
                    :name="'blockyear'+index"
                    :options="blockYears"
                    placeholder="Select Year"
                    @change="(val) => {lta.blockYear = val;getFinancialYear(val)}"
                    v-model="lta.blockYear"
                  />
                </div>
                <div class="col-3">
                  <tl-select
                    class="customwidth"
                    label="Select Financial Year"
                    placeholder="Select Year"
                    v-model="lta.ltaFinancialYear"
                    :options="ltaFinancialYearOptions"
                    @change="(val) => lta.ltaFinancialYear = val"
                  />
                </div>
                <div class="col-3">
                  <txt
                    label="Company Name"
                    type="text"
                    v-model="lta.ltaCompanyName"
                    :name="'ltaCompanyName'+index"
                  ></txt>
                </div>
                <div class="col-2">
                  <txt
                    label="Amount"
                    type="number"
                    v-numeric-only
                    v-maxchars="9"
                    v-model="lta.ltaAmount"
                    :name="'ltaAmount'+index"
                    v-validate="{max: 9}"
                    :classname="errors.has('ltaAmount'+index)"
                    :errormsg="errors.first('ltaAmount'+index)"
                  ></txt>
                </div>
                <div class="col-1 deleteButton" v-if="lta_details.length > 1">
                  <span class="row-container action-img delecteIcon">
                    <img src="@/assets/delete.svg" @click="deleteLTADetails(index)" alt />
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <a
                    href="javascript:void(0)"
                    class="add-new margin-tb-s"
                    @click="getltaDetails"
                  >Add New</a>
                </div>
              </div>
            </div>
          </tl-accordion>

          <tl-accordion headerName="PF, ESI, LWF &amp; PT" :active="true">
            <div slot="accordionBody">
              <div class="form-pf-esi">
                <div class="row headerClass margintop-20">Enable PF</div>
                <div class="margintop-10">
                  <div class="row padding-left-15">
                    <tl-radio
                      name="pf_enabled"
                      label="No"
                      value="no"
                      id="pfnotenabled"
                      v-model="pfesi.pf_enabled"
                      @change="onPFChange(pfesi.pf_enabled)"
                    />
                    <tl-radio
                      name="pf_enabled"
                      label="Yes"
                      value="yes"
                      id="pfenabled"
                      ref="pfenabled"
                      data-vv-as="PF"
                      v-model="pfesi.pf_enabled"
                       @change="onPFChange(pfesi.pf_enabled)"
                    />
                  </div>
                </div>
                <div v-show="pfesi.pf_enabled == 'yes'" class="threeColumnGrid">
                  <txt
                    label="Enter UAN No."
                    name="uan_number"
                    type="text"
                    v-model="pfesi.uan_number"
                    data-vv-as="UAN no."
                    v-numeric-only
                    v-validate="{required:false}"
                    :classname="errors.has('uan_number')"
                    :errormsg="errors.first('uan_number')"
                  ></txt>
                  <!-- v-validate="'required_if:pfenabled,yes'" -->
                  <txt
                    label="PF No."
                    name="pfnumber"
                    type="text"
                    v-model="pfesi.pf_number"
                    data-vv-as="PF no."
                    v-numeric-only
                    v-validate="{required:false}"
                    :classname="errors.has('pfnumber')"
                    :errormsg="errors.first('pfnumber')"
                  ></txt>
                  <div>
                    <span class="input-label datePicker">PF Enrollment Date</span>
                    <!-- UAT 142(PF Enrolment date should be by default date of joining with option to change it to future date but not date before date of joining) - 29/11/2019 -->
                    <date-picker
                      type="text"
                      name="pf_enrollment_date"
                      :dates-disabled="{to: new Date(official.date_of_joining)}"
                      @datevalue="(val)=>pfesi.pf_enrollment_date=val"
                      :value="pfesi.pf_enrollment_date"
                      data-vv-as="PF Enrollment Date"
                      v-validate="{required:false}"
                      :classname="errors.has('pf_enrollment_date')"
                      :errormsg="errors.first('pf_enrollment_date')"
                    />
                  </div>
                  <txt
                    label="Nominee’s Name"
                    name="nomniee_name"
                    type="text"
                    v-model="pfesi.nomniee_name"
                    data-vv-as="Nominee’s Name"
                    v-validate="{required:false}"
                    :classname="errors.has('nomniee_name')"
                    :errormsg="errors.first('nomniee_name')"
                  ></txt>
                  <div>
                    <!-- PL- 1939 - 29/11/2019 -->
                    <span class="input-label datePicker">Date Of Birth</span>
                    <date-picker
                      name="nomniee_dob"
                      @datevalue="(val)=>pfesi.nomniee_dob=val"
                      :dates-disabled="{from: new Date()}"
                      :value="pfesi.nomniee_dob"
                      data-vv-as="date of birth"
                      v-validate="{required:false}"
                      :classname="errors.has('nomniee_dob')"
                      :errormsg="errors.first('nomniee_dob')"
                    ></date-picker>
                  </div>
                  <tl-select
                    label="Relationship"
                    name="relationship"
                    :options="relationshipList"
                    v-model="relationship"
                    @change="(val)=>{relationship = val; pfesi.relationship=val}"
                    data-vv-as="relationship"
                    v-validate="{required:false}"
                    :classname="errors.has('relationship')"
                    :errormsg="errors.first('relationship')"
                  />
                  </div>
                   <div v-show="pfesi.pf_enabled == 'yes'">
                   <txt
                    v-if="is_pf_wage_enabled"
                    label="PF Wage"
                    name="pf_wage"
                    type="text"
                    v-model="pfesi.pf_wage"
                    data-vv-as="PF Wage."
                    v-numeric-only
                    v-validate="{required:false}"
                    :classname="errors.has('pf_wage')"
                    :errormsg="errors.first('pf_wage')"
                  ></txt>
                  </div>
                  <div v-show="pfesi.pf_enabled == 'yes'">
                  <div class="singleColumns margintop-32 margin">
                    <tl-select 
                      label="Employee PF Contribution Rule *" 
                      name="employeePfContribution" 
                      labelText="name"
                      :options="contribution_rule" 
                      v-model="employeecontributionrule" 
                      @change="onPfRuleChange($event, 'employee')"
                      data-vv-as="employee PF contribution rule" 
                      v-validate="'required_if:pfenabled,yes'"
                      :classname="errors.has('employeePfContribution')" 
                      :errormsg="errors.first('employeePfContribution')">
                    </tl-select>
                  </div>
                  <div class="row margintop-16" v-if="restrictedWagesEmployee">
                    <div class="bg-grey">
                      <div class="col-12">
                        <b>If Basic + DA &gt; 15000 (Monthly)</b>
                      </div>
                      <div class="col-12 margin-l-s">
                        <p>PF = 12% of 15000</p>
                      </div>
                      <div class="col-12">
                        <b>If Basic + DA &lt;= 15000 (Monthly)</b>
                      </div>
                      <div class="col-12">
                        <p class="margin-l-s">PF = 12 % of (PF Wages or INR 15000 whichever is lower)</p>
                        <p class="margin-t-s">PF Wages = All Fixed Gross Components - Food-HRA-Statutory Bonus ​</p>
                      </div>
                    </div>
                  </div>
                  <div class="row margintop-16" v-if="nonRestrictedWagesEmployee">
                    <div class="bg-grey">
                      <div class="col-12">
                        <b>If Basic + DA &gt; 15000 (Monthly)</b>
                      </div>
                      <div class="col-12 margin-l-s">
                        <p>PF = 12 % of Basic + DA</p>
                      </div>
                      <div class="col-12">
                        <b>If Basic + DA &lt;= 15000 (Monthly)</b>
                      </div>
                      <div class="col-12">
                        <p class="margin-l-s">PF = 12 % of (PF Wages or INR 15000 whichever is lower)</p>
                        <p class="margin-t-s">PF Wages = All Fixed Gross Components - Food-HRA-Statutory Bonus ​</p>
                      </div>
                    </div>
                  </div>
              </div>
                <div v-show="pfesi.pf_enabled == 'yes'">
                <div class="singleColumns margintop-32">
                  <tl-select 
                    label="Employer PF Contribution Rule *" 
                    name="employerPfContribution" 
                    labelText="name"
                    :options="contribution_rule" 
                    :class="{'remove-arrow':(restrictedWagesEmployee || nonRestrictedWagesEmployee) }" 
                    :disable="(restrictedWagesEmployee || nonRestrictedWagesEmployee)"
                    v-model="employercontributionrule" 
                    @change="onPfRuleChange($event,'employer')"
                    data-vv-as="employer PF contribution rule" 
                    v-validate="'required_if:pfenabled,yes'"
                    :classname="errors.has('employerPfContribution')" 
                    :errormsg="errors.first('employerPfContribution')">
                  </tl-select>
                </div>
                
                <div class="row margintop-16" v-if="restrictedWagesEmployer">
                  <div class="bg-grey">
                    <div class="col-12">
                      <b>If Basic + DA &gt; 15000 (Monthly)</b>
                    </div>
                    <div class="col-12 margin-l-s">
                      <p>PF = 12 % of 15000</p>
                    </div>
                    <div class="col-12">
                      <b>If Basic + DA &lt;= 15000 (Monthly)</b>
                    </div>
                    <div class="col-12">
                      <p class="margin-l-s">PF = 12 % of (PF Wages or INR 15000 whichever is lower)</p>
                      <p class="margin-t-s">PF Wages = All Fixed Gross Components - Food-HRA-Statutory Bonus ​</p>
                    </div>
                  </div>
                </div>
                
                <div class="row margintop-16" v-if="nonRestrictedWagesEmployer">
                  <div class="bg-grey">
                    <div class="col-12">
                      <b>If Basic + DA &gt; 15000 (Monthly)</b>
                    </div>
                    <div class="col-12 margin-l-s">
                      <p>PF = 12 % of Basic + DA</p>
                    </div>
                    <div class="col-12">
                      <b>If Basic + DA &lt;= 15000 (Monthly)</b>
                    </div>
                    <div class="col-12">
                      <p class="margin-l-s">PF = 12 % of (PF Wages or INR 15000 whichever is lower)</p>
                      <p class="margin-t-s">PF Wages = All Fixed Gross Components - Food-HRA-Statutory Bonus ​</p>
                    </div>
                  </div>
                </div>
              </div>

                <div class="row headerClass margintop-20">Entitled to ESI</div>
                <div class="row padding-left-15">
                  <tl-radio
                    name="entitled_esi"
                    label="No"
                    id="noESI"
                    value="no"
                    v-model="pfesi.entitled_esi"
                    @change="onESIChange(pfesi.entitled_esi)"
                  ></tl-radio>
                  <tl-radio
                    name="entitled_esi"
                    label="Yes"
                    id="yesESI"
                    value="yes"
                    ref="yesESI"
                    data-vv-as="ESI"
                    v-model="pfesi.entitled_esi"
                  ></tl-radio>
                </div>
                <div v-show="pfesi.entitled_esi == 'yes'">
                  <txt
                    name="esi_number"
                    label="ESI No."
                    type="text"
                    v-numeric-only
                    v-model="pfesi.esi_number"
                    data-vv-as="ESI number"
                    v-validate="{required:false}"
                    :classname="errors.has('esi_number')"
                    :errormsg="errors.first('esi_number')"
                  ></txt>
                </div>
              </div>
              <div class="margintop-20">
                <tl-checkbox
                  name="lwf_applicable"
                  label="Applicable to LWF"
                  value="no"
                  id="lwf_applicable"
                  v-model="pfesi.lwf_applicable"
                ></tl-checkbox>
              </div>
               <div class="margintop-20">
                <tl-checkbox
                  name="eps_applicable"
                  label="Applicable to EPS"
                  value="no"
                  id="eps_applicable"
                  v-model="pfesi.eps_applicable"
                ></tl-checkbox>
              </div>
               <div class="margintop-20">
                <tl-checkbox
                  name="international_employee"
                  label="International Employee"
                  value="no"
                  id="international_employee"
                  v-model="pfesi.international_employee"
                ></tl-checkbox>
              </div>
              <div class="margintop-20">
                <tl-checkbox
                  name="Applicable_to_pT"
                  id="Applicable_to_pT"
                  ref="pt_applicable"
                  label="Applicable to PT"
                  :disabled="locationPT"
                  v-model="pfesi.pt_applicable"
                  @change="onPTChange(pfesi.pt_applicable)"
                ></tl-checkbox>
                <div v-if="checkboxPT">
                  <tl-select
                    class="margin-t-s"
                    labelText="display_name"
                    label="PT State*"
                    name="PT_state"
                    :options="ptSatateOptions"
                    v-model="pt_state_id"
                    :disabled="true"
                    @change="(val)=> {pt_state_id = val;pfesi.pt_state_id = val? val.id:null, onPtStateChange(val)}"
                    data-vv-as="PT State"
                    v-validate="'required_if:pt_applicable,true'"
                    :classname="errors.has('PT_state')"
                    :errormsg="errors.first('PT_state')"
                  ></tl-select>
                  <tl-select
                    name="deductionfrequency"
                    class="margin-t-s"
                    label="Deduction Frequency*"
                    labelText="name"
                    :options="deductionFrequencyOptions"
                    v-model="pt_deduction_frequency"
                    @change="(val) => {pt_deduction_frequency = val;pfesi.pt_deduction_frequency = val? val.id:null}"
                    data-vv-as="Deduction Frequency"
                    v-validate="'required_if:pt_applicable,true'"
                    :classname="errors.has('deductionfrequency')"
                    :errormsg="errors.first('deductionfrequency')"
                    :disabled="true"
                  ></tl-select>
                </div>
              </div>
              <div class="margintop-20">
                <!-- <tl-checkbox
                  name="Eligible_for_Minimum_Wages"
                  label="Eligible for Minimum Wages"
                  ref="minimum_wage"
                  v-model="pfesi.minimum_wage_eligible"
                  @change="onMinimumWageChange(pfesi.minimum_wage_eligible)"
                ></tl-checkbox> -->
                <div v-if="pfesi.minimum_wage_eligible">
                  <!-- Start PL_2669 -->
                  <tl-select
                    class="margin-t-s"
                    label="Industry Type"
                    name="minimum_wage_industry_type"
                    labelText="name"
                    :placeholder="'Select'"
                    :disable="location_id?location_id.minimumWageSame:false"
                    :options="industrytype"
                    v-model="minimum_wage_industry_type"
                    @change="(val) => {minimum_wage_industry_type=val;pfesi.minimum_wage_industry_type = val? val.id:null}"
                  ></tl-select>
                  <tl-select
                    name="minimum_wage_zone_id"
                    class="margin-t-s"
                    label="Minimum Wage Zone"
                    labelText="name"
                    :disable="location_id?location_id.minimumWageSame:false"
                    :options="minimumWageZoneList"
                    v-model="minimum_wage_zone_id"
                    @change="(val) => {minimum_wage_zone_id = val;pfesi.minimum_wage_zone_id = val? val.id:null}"
                  ></tl-select>

                  <div class="row headerClass margintop-20">Wages Calculated On*</div>
                  <div class="margintop-10">
                    <div class="row padding-left-15">
                      <tl-radio
                        name="wageType"
                        label="Basic + DA "
                        id="basic"
                        :disabled="location_id?location_id.minimumWageSame:false"
                        value="BDA"
                        v-model="pfesi.minimum_wage_calculated_on"
                      />
                      <tl-radio
                        name="wageType"
                        label="Fixed Gross Salary "
                        id="fixedGross"
                        :disabled="location_id?location_id.minimumWageSame:false"
                        value="Gross"
                        v-model="pfesi.minimum_wage_calculated_on"
                      />
                      <!-- End PL_2669 -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </tl-accordion>

          <tl-accordion headerName="Salary Details" :active="true">
            <div slot="accordionBody">
              <div class="row">
                <div class="col-3 padding-l-n">
                  <tl-select
                    class="customwidth"
                    label="Salary Structure*"
                    labelText="name"
                    name="salary_structure"
                    data-vv-as="salary structure"
                    :options="salarystructure"
                    v-model="salaryStructureObj"
                    @change="(val)=>{salaryStructureObj = val;fetchAllSalarycomponentsData(val? val.sssc:null, val? val.id:null)}"
                    v-validate="'required'"
                    :classname="errors.has('salary_structure')"
                    :errormsg="errors.first('salary_structure')"
                  ></tl-select>
                  <br />
                 <!-- <div class="add-new" @click="addSalaryStructure">Add New</div> --> <!-- PL-1588-->
                </div>
                <div class="col-3">
                  <txt
                    label="Enter CTC*"
                    type="number"
                    name="ctc"
                    data-vv-name="ctc"
                    v-numeric-only
                    v-maxchars="9"
                    v-model="salary.ctc"
                    v-validate="'required|max:9'"
                    :classname="errors.has('ctc')"
                    :errormsg="errors.first('ctc')"
                  ></txt>
                </div>
                <div class="col-3 margin-t-25px">
                  <button class="export-button" @click="calculateSalary()">Calculate</button>
                </div>
              </div>
              <div>
                <span class="input-label">Salary Effective Date</span>
                <date-picker 
                  type="text" 
                  name="salary_effective_date"
                  :dates-disabled="{to: new Date(official.date_of_joining)}"
                  @datevalue="(val)=>salary.salary_effective_date = val" 
                  :value="salary.salary_effective_date"
                 />
              </div>
              <div class="row margin-t-m margin-l-n">
                <div class="col-12 padding-l-n">
                  <tl-checkbox
                    label="Exempt employee from IT deduction for the first month"
                    name="exempt_for_it_deduction_first_month"
                    v-model="salary.exempt_for_it_deduction_first_month"
                  ></tl-checkbox>
                </div>
                <div class="col-12 padding-l-n mt-2">
                  <tl-checkbox
                    label="Enable FBP ESS"
                    name="enable_fbp_ess"
                    v-model="personal.enable_fbp_ess"
                  ></tl-checkbox>
                </div>
              </div>
              <!-- Start PL_2507 -->
              <div class="row margin-t-m">
                <div class="col-12 padding-l-n">
                  <table class="salaryDetails">
                    <thead>
                      <tr>
                        <th></th>
                        <th>
                          <tl-checkbox
                            name="componentName"
                            label="Component Name"
                            v-model="isAllComponentSelected"
                            @change="onAllComponentSelect($event)"
                          ></tl-checkbox>
                        </th>
                        <th>Monthly Amount ( ₹ )</th>
                        <th>Annual Amount (₹)</th>
                        <th>Calculation</th>
                      </tr>
                    </thead>
                    <tbody v-for="(item, index) in salaryTableData" :key="index">
                      <tr v-for="(comp, idx) in item.components" :key="idx">
                        <td>{{idx ? '':item.category}}</td>
                        <td>
                          <tl-checkbox
                            :name="'componentName'+index+idx"
                            :label="comp.name"
                            v-model="comp.isSelected"
                            @change="onComponentSelect(comp,comp.isSelected, idx, index)"
                          ></tl-checkbox>
                        </td>
                        <td>
                          <txt
                            type="number"
                            :name="'monthly'+index+idx"
                            v-model="comp.monthly"
                            v-numeric-only
                            v-maxchars="9"
                            @change="() =>{calculateTotalMonthly(index, idx); comp.isEdited = true;}"
                            data-vv-as="monthly amount"
                            v-validate="{max: 9}"
                            :classname="errors.has('monthly'+index+idx)"
                            :errormsg="errors.first('monthly'+index+idx)"
                          />
                        </td>
                        <td>
                          <txt
                            type="number"
                            :name="'annual'+index+idx"
                            v-model="comp.annual"
                            v-numeric-only
                            v-maxchars="9"
                            @change="() => {calculateTotalAnnual(index, idx);comp.isEdited = true;}"
                            data-vv-as="annual amount"
                            v-validate="{max: 9}"
                            :classname="errors.has('annual'+index+idx)"
                            :errormsg="errors.first('annual'+index+idx)"
                          />
                        </td>
                        <td>{{comp.formula}}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td>
                          <b>Total</b>
                        </td>
                        <td>
                          <span>
                            <b>Rs. {{item.total_monthly}}</b>
                          </span>
                        </td>
                        <td>
                          <span>
                            <b>Rs. {{item.total_annual}}</b>
                          </span>
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- End PL_2507 -->
              <div class="header header2 margin-t-l">
                <span class="text">Fixed Non CTC Components</span>
              </div>
              <p>{{assignedComponentsList.length}} Non CTC Components assigned</p>

              <div class="margintop-30">
                <div class="datatable-outer-container margintop-30">
                  <table class="datatable">
                    <thead>
                      <tr class="header-row">
                        <th>Component</th>
                        <th>Amount</th>
                        <th>Applicable From</th>
                        <th>Applicable Till</th>
                        <th></th>
                      </tr>
                    </thead>
                    <!-- </tr> -->
                    <tr
                      class="record-row"
                      v-for="(item, index) in assignedComponentsList"
                      :key="index"
                    >
                      <td>
                        <tl-select
                          labelText="name"
                          :name="'assignedcomponents'+index"
                          :options="nonCtcComponentsList"
                          v-model="item.componentObj"
                          @change="componentChanged($event,index)"
                        />
                        <!-- <br />
                        <a
                          href="javascript:void(0)"
                          class="salaryadvancesetting"
                          @click="nonctcadvancesetting(item,index)"
                        >Advance Setting</a>-->
                      </td>
                      <td>
                        <input
                          v-if="!(item.advance_setting && item.advance_setting.length)"
                          type="text"
                          class="inputbox custom-input"
                          :name="'assignedamount'+index"
                          v-model="item.value"
                          maxlength="9"
                          data-vv-as="amount"
                          v-validate="{max: 9}"
                          :classname="errors.has('assignedamount'+index)"
                          :errormsg="errors.first('assignedamount'+index)"
                          v-numeric-only
                        />
                        <p v-else>Custom</p>
                      </td>
                      <td>
                        <date-picker
                          class="ht-35 margin-top-5"
                          :name="'applicableFrom'+index"
                          @datevalue="(val)=>item.from=val"
                          :value="item.from"
                          :formatDate="'dd-MM-yyyy'"
                        />
                      </td>
                      <td>
                        <date-picker
                          class="ht-35 margin-top-5"
                          :name="'applicableTill'+index"
                          @datevalue="(val)=>item.to=val"
                          :disable="!item.from"
                          :dates-disabled="{to:new Date(item.from)}"
                          :value="item.to"
                          :formatDate="'dd-MM-yyyy'"
                        />
                      </td>
                      <td>
                        <span class="row-container action-img">
                          <img src="@/assets/delete.svg" @click="deleteRecord(index)" alt />
                        </span>
                      </td>
                    </tr>
                  </table>

                  <div class="flex-box align-center margin-tb-l">
                    <div class="row-container">
                      <img src="@/assets/group-5.svg" />
                      <button class="text-green" @click="addNonCTCcomponent()">Add Non CTC Component</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </tl-accordion>
          <tl-accordion headerName="Employee Documents" :active="true">
            <div slot="accordionBody">
              <tl-tabs :tabs="tabs" :customclass="true" class="margintop-20">
                <tl-tab>
                  <data-table
                    :columns="EmployeeDocsColumns"
                    :tableData="DocumentData"
                    :checkbox="false"
                    :withForm="false"
                    :showinrow="false"
                    :showhistory="false"
                    :showinheader="false"
                  >
                    <template v-slot:rowcontent="slotprops">
                      <p
                        v-if="slotprops.value.column.key=='name'"
                      >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                      <p v-if="slotprops.value.column.key=='location'">
                        <a
                          :href="slotprops.value.record.location"
                          :alt="slotprops.value.record.name"
                          target="_blank"
                        >{{slotprops.value.record.location}}</a>
                      </p>
                      <span
                        class="row-container action-img align-center"
                        v-if="slotprops.value.column.key=='action'"
                      >
                        <div class="attach_file">
                          <label class="fileLabel" :for="'file_PERSONNEL'+slotprops.value.index">
                            <img src="@/assets/logout-copy-2.png" alt />
                            <input
                              type="file"
                              :placeholder="'No file Choosen'"
                              :id="'file_PERSONNEL'+slotprops.value.index"
                              @change="uploadFile($event.target.files[0], slotprops.value, 'PERSONNEL')"
                            />
                          </label>
                        </div>

                        <span class="grey-divider" />
                        <!-- UAT 170 (Delete option should be enabled only if any files are uploaded) - 28/11/2019 -->
                        <img
                          v-if="slotprops.value.record.location"
                          :src="require('@/assets/delete.svg')"
                          alt="delete"
                          @click="deleteDocumentFile(slotprops.value, 'personal')"
                        />
                      </span>
                    </template>
                  </data-table>
                  <!-- start UAT_166 -->
                  <btn
                    text="Add New Document"
                    type="secondary"
                    class="addNewDocument"
                    v-if="!personalDocument"
                    @click="createpersonalrow()"
                  ></btn>
                  <div class="row" v-if="personalDocument">
                    <div class="col-4">
                      <txt type="text" v-model="documentObj.name" name="documentName"></txt>
                    </div>
                    <div class="col-4"></div>
                    <div class="col-4">
                      <btn
                        type="primary"
                        text="Add"
                        :disabled="documentObj.name ? false : true"
                        @click="pushpersonalDocument(documentObj)"
                        class="addPersonalDoc"
                      ></btn>
                      <btn
                        type="secondary"
                        text="cancel"
                        @click="cancelpersonalDocument(documentObj)"
                      ></btn>
                    </div>
                  </div>
                  <!-- End UAT_166 -->
                </tl-tab>
                <tl-tab>
                  <data-table
                    :columns="EmployeeDocsColumns"
                    :tableData="ProfessionalDocumentData"
                    :checkbox="false"
                    :withForm="false"
                    :showinrow="false"
                    :showhistory="false"
                    :showinheader="false"
                  >
                    <template v-slot:rowcontent="slotprops">
                      <p
                        v-if="slotprops.value.column.key=='name'"
                      >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                      <p v-if="slotprops.value.column.key=='location'">
                        <a
                          :href="slotprops.value.record.location"
                          :alt="slotprops.value.record.name"
                          target="_blank"
                        >{{slotprops.value.record.location}}</a>
                      </p>
                      <span
                        class="row-container action-img align-center"
                        v-if="slotprops.value.column.key=='action'"
                      >
                        <div class="attach_file">
                          <label class="fileLabel" :for="'file_PROFESSIONAL'+slotprops.value.index">
                            <img src="@/assets/logout-copy-2.png" alt />
                            <input
                              type="file"
                              :id="'file_PROFESSIONAL'+slotprops.value.index"
                              @change="uploadFile($event.target.files[0], slotprops.value, 'PROFESSIONAL')"
                            />
                          </label>
                        </div>
                        <span class="grey-divider" />
                        <!-- UAT 170 (Delete option should be enabled only if any files are uploaded) - 28/11/2019 -->
                        <img
                          v-if="slotprops.value.record.location"
                          :src="require('@/assets/delete.svg')"
                          alt="delete"
                          @click="deleteDocumentFile(slotprops.value, 'professional')"
                        />
                      </span>
                    </template>
                  </data-table>
                  <!-- start UAT_166 -->
                  <btn
                    text="Add New Document"
                    type="secondary"
                    class="addNewDocument"
                    v-if="!proffesionalDocument"
                    @click="createproffesionalrow()"
                  ></btn>
                  <div class="row" v-if="proffesionalDocument">
                    <div class="col-4">
                      <txt type="text" v-model="ProfessionaldocumentObj.name" name="documentName"></txt>
                    </div>
                    <div class="col-4"></div>
                    <div class="col-4">
                      <btn
                        type="primary"
                        text="Add"
                        :disabled="ProfessionaldocumentObj.name ? false : true"
                        @click="pushproffesionalDocument(ProfessionaldocumentObj)"
                        class="addPersonalDoc"
                      ></btn>
                      <btn
                        type="secondary"
                        text="cancel"
                        @click="cancelproffesionalDocument(ProfessionaldocumentObj)"
                      ></btn>
                    </div>
                  </div>
                  <!-- End UAT_166 -->
                </tl-tab>
                <tl-tab>
                  <data-table
                    :columns="EmployeeDocsColumns"
                    :tableData="EducationalDocumentsData"
                    :checkbox="false"
                    :withForm="false"
                    :showinrow="false"
                    :showhistory="false"
                    :showinheader="false"
                  >
                    <template v-slot:rowcontent="slotprops">
                      <p
                        v-if="slotprops.value.column.key=='name'"
                      >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                      <p v-if="slotprops.value.column.key=='location'">
                        <a
                          :href="slotprops.value.record.location"
                          :alt="slotprops.value.record.name"
                          target="_blank"
                        >{{slotprops.value.record.location}}</a>
                      </p>
                      <span
                        class="row-container action-img align-center"
                        v-if="slotprops.value.column.key=='action'"
                      >
                        <div class="attach_file">
                          <label class="fileLabel" :for="'file_EDUCATIONAL'+slotprops.value.index">
                            <img src="@/assets/logout-copy-2.png" alt />
                            <input
                              type="file"
                              :id="'file_EDUCATIONAL'+slotprops.value.index"
                              @change="uploadFile($event.target.files[0], slotprops.value, 'EDUCATIONAL')"
                            />
                          </label>
                        </div>

                        <span class="grey-divider" />
                        <!-- UAT 170 (Delete option should be enabled only if any files are uploaded) - 28/11/2019 -->
                        <img
                          v-if="slotprops.value.record.location"
                          :src="require('@/assets/delete.svg')"
                          alt="delete"
                          @click="deleteDocumentFile(slotprops.value, 'educational')"
                        />
                      </span>
                    </template>
                  </data-table>
                  <!-- start UAT_166 -->
                  <btn
                    text="Add New Document"
                    type="secondary"
                    class="addNewDocument"
                    v-if="!educationalDocument"
                    @click="createEducationrow()"
                  ></btn>
                  <div class="row" v-if="educationalDocument">
                    <div class="col-4">
                      <txt type="text" v-model="educationaldocumentObj.name" name="documentName"></txt>
                    </div>
                    <div class="col-4"></div>
                    <div class="col-4">
                      <btn
                        type="primary"
                        text="Add"
                        :disabled="educationaldocumentObj.name ? false : true"
                        @click="pusheducationalDocument(educationaldocumentObj)"
                        class="addPersonalDoc"
                      ></btn>
                      <btn
                        type="secondary"
                        text="cancel"
                        @click="canceleducationalDocument(educationaldocumentObj)"
                      ></btn>
                    </div>
                  </div>
                  <!-- End UAT_166 -->
                </tl-tab>
              </tl-tabs>
            </div>
          </tl-accordion>
          <tl-accordion headerName="Payment Details" :active="true">
            <div slot="accordionBody">
              <div class="threeColumnGrid">
                <tl-select
                  label="Mode of Payment"
                  name="paymentType"
                  :options="modeofpayment"
                  v-model="bank.paymentType"
                  @change="(val)=> bank.paymentType = val"
                ></tl-select>
              </div>
              <br />
              <div class="row" v-show="bank.paymentType !== 'Cash'">
                <div class="col-4 margintop-20">
                  <txt
                    :label="bank.paymentType == 'Transfer' ? 'Account Holder’s Name*':'Account Holder’s Name'"
                    name="account_holder_name"
                    type="text"
                    v-model="bank.account_holder_name"
                    v-validate="{required:(bank.paymentType == 'Transfer') ? true:false}"
                    :classname="errors.has('account_holder_name')"
                    :errormsg="errors.first('account_holder_name')"
                  ></txt>
                </div>
                <div class="col-4 margintop-20">
                  <txt
                    :label="bank.paymentType == 'Transfer' ? 'Account Number*': 'Account Number'"
                    type="text"
                    name="AccountNumber"
                    v-numeric-only
                    data-vv-as="account number"
                    v-model="bank.account_number"
                    v-validate="{required:(bank.paymentType == 'Transfer') ? true:false}"
                    :classname="errors.has('AccountNumber')"
                    :errormsg="errors.first('AccountNumber')"
                  ></txt>
                </div>
                <div class="col-4 margintop-20">
                  <tl-select
                    label="Account Type"
                    name="account_type"
                    :options="['Personal', 'Joint']"
                    v-model="bank.account_type"
                    @change="(val) => bank.account_type = val"
                  ></tl-select>
                </div>
                <div class="col-4 margintop-20">
                  <tl-select
                    :label="bank.paymentType == 'Transfer' ? 'Bank Name*': 'Bank Name'"
                    labelText="name"
                    name="bankName"
                    :options="bankList"
                    v-model="payroll_bank_id"
                    @change="(val) => {payroll_bank_id=val;bank.bank_name = val.id}"
                    data-vv-as="bank name"
                    v-validate="{required:(bank.paymentType == 'Transfer') ? true:false}"
                    :classname="errors.has('bankName')"
                    :errormsg="errors.first('bankName')"
                  ></tl-select>
                </div>
                <!-- start UAT_186 -->
                <div class="col-4 margintop-20">
                  <txt
                    label="IFSC Code"
                    type="text"
                    name="IFSCCode"
                    data-vv-as="IFSC code"
                    v-model="bank.ifsc_code"
                    @change="(val)=> bank.ifsc_code = val.toUpperCase()"
                    v-validate="{required: false, regex:ifscRegex, length:11}"
                    :classname="errors.has('IFSCCode')"
                    :errormsg="errors.first('IFSCCode')"
                  ></txt>
                </div>
                <!-- End UAT_186 -->
                <div class="col-4 margintop-20">
                  <tl-select
                    label="Type of Bank Transfer"
                    name="bank_transfer_type"
                    :options="banktransfertype"
                    v-model="bank.bank_transfer_type"
                    @change="(val) => bank.bank_transfer_type = val"
                  ></tl-select>
                </div>
                <div class="col-4 margintop-20">
                  <!-- MICR Code error message duplicate Issue PL-2059 -->
                  <txt
                    label="MICR Code"
                    name="Micr_code"
                    type="text"
                    v-numeric-only
                    maxlength="9"
                    data-vv-as="micr code"
                    v-model="bank.micr_code"
                    v-validate="{length:9}"
                    :classname="errors.has('Micr_code')"
                    :errormsg="errors.first('Micr_code')"
                  ></txt>
                </div>
                <div class="col-4 margintop-20">
                  <txt label="UPI Address " type="text" v-model="bank.upi"></txt>
                </div>
                <div class="col-4 margintop-20">
                  <txt   label="Branch Name " type="text" v-model="bank.branch_name" :disable="!bank.account_number"
                    v-validate="{required:(bank.paymentType == 'Transfer') ? true:false}"
                    data-vv-as="branch name"
                     name="branch_name"
                    :classname="errors.has('branch_name')"
                    :errormsg="errors.first('branch_name')"
                  ></txt>
                </div>
              </div>
              <br />
              <a
                class="link"
                v-if="!showanotheraccount && bank.paymentType !== 'Cash'"
                @click="addanotheraccount"
              >Add Another Account</a>
              <br />
              <div v-if="showanotheraccount">
                <div class="newaccountdetails">Another Bank Account Details</div>
                <div class="row">
                  <div class="col-4 margintop-20">
                    <!-- PL_3067 -->
                    <txt
                      :label="bank.paymentType == 'Transfer' ? 'Account Holder’s Name*':'Account Holder’s Name'"
                      name="other_account_holder_name"
                      type="text"
                      data-vv-as="account holder name"
                      v-model="bank.addbank.account_holder_name"
                      v-validate="{required:((bank.paymentType == 'Transfer') && showanotheraccount) ? true: false}"
                      :classname="errors.has('other_account_holder_name')"
                      :errormsg="errors.first('other_account_holder_name')"
                    ></txt>
                  </div>
                  <div class="col-4 margintop-20">
                    <!-- PL_3067 -->
                    <txt
                      :label="bank.paymentType == 'Transfer' ? 'Account Number*': 'Account Number'"
                      type="text"
                      name="otherAccountNumber"
                      v-numeric-only
                      data-vv-as="account number"
                      v-model="bank.addbank.account_number"
                      v-validate="{required:((bank.paymentType == 'Transfer') && showanotheraccount) ? true: false}"
                      :classname="errors.has('otherAccountNumber')"
                      :errormsg="errors.first('otherAccountNumber')"
                    ></txt>
                  </div>
                  <div class="col-4 margintop-20">
                    <tl-select
                      label="Account Type"
                      name="account_type"
                      :options="['Personal', 'Joint']"
                      v-model="bank.addbank.account_type"
                      @change="(val) => bank.addbank.account_type = val"
                    ></tl-select>
                  </div>
                  <div class="col-4 margintop-20">
                    <!-- PL_3067 -->
                    <tl-select
                      :label="bank.paymentType == 'Transfer' ? 'Bank Name*': 'Bank Name'"
                      labelText="name"
                      name="otherBankName"
                      :options="bankList"
                      v-model="other_bank_id"
                      data-vv-as="bank name"
                      @change="(val) => {other_bank_id=val;bank.addbank.bank_name = val.id}"
                      v-validate="{required:((bank.paymentType == 'Transfer') && showanotheraccount) ? true: false}"
                      :classname="errors.has('otherBankName')"
                      :errormsg="errors.first('otherBankName')"
                    ></tl-select>
                  </div>

                  <div class="col-4 margintop-20">
                    <txt
                      label="IFSC Code"
                      type="text"
                      name="IFSCCode2"
                      data-vv-as="IFSC code"
                      v-model="bank.addbank.ifsc_code"
                      @change="(val)=> lbank.addbank.ifsc_code = val.toUpperCase()"
                      v-validate="{required: false, regex:ifscRegex, length:11}"
                      :classname="errors.has('IFSCCode2')"
                      :errormsg="errors.first('IFSCCode2')"
                    ></txt>
                  </div>
                  <div class="col-4 margintop-20">
                    <tl-select
                      label="Type of Bank Transfer"
                      name="bank_transfer_type"
                      :options="banktransfertype"
                      v-model="bank.addbank.bank_transfer_type"
                      @change="(val) => bank.addbank.bank_transfer_type = val"
                    ></tl-select>
                  </div>
                  <div class="col-4 margintop-20">
                    <txt
                      label="MICR Code"
                      name="othermicr"
                      type="text"
                      v-numeric-only
                      maxlength="9"
                      data-vv-as="micr code"
                      v-model="bank.addbank.micr_code"
                      v-validate="{length:9}"
                      :classname="errors.has('othermicr')"
                      :errormsg="errors.first('othermicr')"
                    ></txt>
                  </div>
                  <div class="col-4 margintop-20">
                    <txt
                      label="Credit (%)"
                      type="text"
                      name="credit"
                      v-model="bank.addbank.credit"
                      :classname="errors.has('credit')"
                      :errormsg="errors.first('credit')"
                    ></txt>
                  </div>
                  <div class="col-4 margintop-20">
                    <txt
                      label="Branch Name"
                      type="text"
                      :disable="!bank.addbank.account_number"
                      v-model="bank.addbank.branch_name"
                      v-validate="{required:(bank.paymentType == 'Transfer') ? true:false}"
                     data-vv-as="branch name"
                     name="branch_name"
                    :classname="errors.has('branch_name')"
                    :errormsg="errors.first('branch_name')"
                    ></txt>
                  </div>
                  <div class="col-4 margintop-20 link" v-on:click="deleteAccount">Delete Account</div>
                </div>
              </div>

              <tl-checkbox
                label="Same Account For FBP?"
                name="same_acc_fbp"
                v-show="bank.paymentType !== 'Cash'"
                class="margin-t-m"
                v-model="bank.same_acc_fbp"
                @change="(val)=>{bank.same_acc_fbp=val; setFbpAsSame();}"
              ></tl-checkbox>
              <!-- {{sameAccFBP}}  -->
              <div class="row" v-if="!bank.same_acc_fbp">
                <div class="col-4 margintop-20">
                  <!-- PL_3067 -->
                  <txt
                    :label="bank.paymentType == 'Transfer' ? 'Account Holder’s Name*':'Account Holder’s Name'"
                    name="fbp_account_holder_name"
                    type="text"
                    data-vv-as="account holder's name"
                    v-model="bank.fbp.account_holder_name"
                    v-validate="{required:((bank.paymentType == 'Transfer') && !bank.same_acc_fbp) ? true: false}"
                    :classname="errors.has('fbp_account_holder_name')"
                    :errormsg="errors.first('fbp_account_holder_name')"
                  ></txt>
                </div>
                <div class="col-4 margintop-20">
                  <!-- PL_3067 -->
                  <txt
                    :label="bank.paymentType == 'Transfer' ? 'Account Number*': 'Account Number'"
                    type="text"
                    v-numeric-only
                    name="fbp_account_number"
                    data-vv-as="account number"
                    v-model="bank.fbp.account_number"
                    v-validate="{required:((bank.paymentType == 'Transfer') && !bank.same_acc_fbp) ? true: false}"
                    :classname="errors.has('fbp_account_number')"
                    :errormsg="errors.first('fbp_account_number')"
                  ></txt>
                </div>
                <div class="col-4 margintop-20">
                  <tl-select
                    label="Account Type"
                    name="fbp_account_type"
                    :options="['Personal', 'Joint']"
                    v-model="bank.fbp.account_type"
                    @change="(val) => bank.fbp.account_type = val"
                  />
                </div>
                <div class="col-4 margintop-20">
                  <!-- PL_3067 -->
                  <tl-select
                    :label="bank.paymentType == 'Transfer' ? 'Bank Name*': 'Bank Name'"
                    labelText="name"
                    name="fbp_bank_name"
                    :options="bankList"
                    v-model="fbp_bank_id"
                    @change="(val) => {fbp_bank_id=val;bank.fbp.bank_name = val.id}"
                    data-vv-as="bank name"
                    v-validate="{required:((bank.paymentType == 'Transfer') && !bank.same_acc_fbp) ? true: false}"
                    :classname="errors.has('fbp_bank_name')"
                    :errormsg="errors.first('fbp_bank_name')"
                  ></tl-select>

                </div>
                <div class="col-4 margintop-20">
                  <txt
                    label="IFSC Code"
                    type="text"
                    name="fbp_ifsc_code"
                    v-model="bank.fbp.ifsc_code"
                    data-vv-as="IFSC code"
                    v-validate="{required: false, regex:ifscRegex, length:11}"
                    @change="(val)=> bank.fbp.ifsc_code = val.toUpperCase()"
                    :classname="errors.has('fbp_ifsc_code')"
                    :errormsg="errors.first('fbp_ifsc_code')"
                  ></txt>
                </div>
                <div class="col-4 margintop-20">
                  <tl-select
                    label="Type of Bank Transfer"
                    name="fbp_bank_transfer_type"
                    :options="banktransfertype"
                    v-model="bank.fbp.bank_transfer_type"
                    @change="(val) => bank.fbp.bank_transfer_type = val"
                  ></tl-select>
                </div>

                <div class="col-4 margintop-20">
                  <txt
                    label="MICR Code"
                    name="micr_code"
                    type="text"
                    v-numeric-only
                    maxlength="9"
                    data-vv-as="micr code"
                    v-model="bank.fbp.micr_code"
                    v-validate="{length:9}"
                    :classname="errors.has('micr_code')"
                    :errormsg="errors.first('micr_code')"
                  ></txt>
                </div>

                <div class="col-4 margintop-20">
                  <txt label="UPI Address" type="text" v-model="bank.fbp.upi"></txt>
                </div>
                <div class="col-4 margintop-20">
                  <txt label="Branch Name" type="text" v-model="bank.fbp.branch_name" :disable="!bank.fbp.account_number"
                   v-validate="{required:(bank.paymentType == 'Transfer') ? true:false}"
                    data-vv-as="branch name"
                     name="branch_name"
                    :classname="errors.has('branch_name')"
                    :errormsg="errors.first('branch_name')"></txt>
                </div>
              </div>
            </div>
          </tl-accordion>

          <tl-accordion headerName="User Defined Fields" :active="true">
            <div slot="accordionBody">
              <div class="form-pf-esi">
                <div class="noUdfData" v-if="!filteredUdf.length">
                  <span>You have not added any UDF yet.</span>
                </div>
                <div class="row" v-if="filteredUdf.length">
                  <div class="col-3" v-for="data in filteredUdf" :key="data.id">
                    <txt
                      :label="`${data.field_name}`"
                      type="text"
                      :name="`${data.field_name}`"
                      v-model="data.value"
                    ></txt>
                  </div>
                </div>
              </div>
            </div>
          </tl-accordion>
        </div>
        <div class="margin-t-25px" v-if="isJoinComponent">
          <btn text="Add Employee" type="secondary" @click="addEmployee" />
          <div class="lock-list">
            <tl-checkbox label="Lock New Joinees List" @change="(bool)=>locklist(bool)"></tl-checkbox>
          </div>
        </div>
        <bottom-action-container>
          <template slot="end">
            <btn-grp>
              <btn text="Cancel" type="secondary" @click="goBackToDashboardPage" />
              <btn
                :text="btnText"
                :disabled="isJoinComponent && (isLockList == 'No')"
                type="primary"
                @click="submitForm('navigate')"
              />
            </btn-grp>
          </template>
        </bottom-action-container>
      </div>
    </div>
    <!-- <div v-show="!showEmployeeData">
      <div class="business">
        <div class="top-bar">
          <span @click="cancelAdvanceSettings">
            <i class="left"></i>
          </span>
          <span class="heading_new">Advance Settings</span>
          <span class="spacer" />
        </div>

        <div class="main-container">
          <div class="custom-grid margin-top-10">
            <tl-select
              label="Component"
              labelText="name"
              :name="'components'"
              :options="nonCtcComponentsList "
              v-model="assignedComponentsObj.componentObj"
              @change="(val) => {assignedComponentsObj.componentObj = val}"
            />
          </div>
          <div class="custom-grid margin-top-10">
            <div>
              <span class="input-label">Start Date</span>
              <date-picker
                label="Applicable From"
                class="ht-35 margin-top-5"
                name="applicableFromad"
                :value="assignedComponentsObj.from"
                @datevalue="fromDateChanged($event)"
                :formatDate="'dd-MM-yyyy'"
              />
              // @datevalue="(val)=>assignedComponentsObj.applicableFrom_date=val"
              // @datevalue="(val) => {assignedComponentsObj.from = val;fromDateChanged(val);}"
            </div>
            <div>
              <span class="input-label">End Date</span>
              <date-picker
                label="Applicable To"
                class="ht-35 margin-top-5"
                name="applicableToad"
                :value="assignedComponentsObj.to"
                :disable="!assignedComponentsObj.from"
                @datevalue="(val) => { assignedComponentsObj.to = val;toDateChanged();}"
                :dates-disabled="{to:new Date(assignedComponentsObj.from)}"
                :formatDate="'dd-MM-yyyy'"
              />
              // @datevalue="(val)=>assignedComponentsObj.applicableTo_date=val"
            </div>
          </div>

          <div class="datatable-outer-container margin-top-30">
            <table class="datatable">
              <thead>
                <tr class="header-row">
                  <th>S.no</th>
                  <th>Schedule Date</th>
                  <th>Amount</th>
                </tr>
              </thead>
              // </tr>
              <tr
                class="record-row"
                v-for="(item, index) in assignedComponentsObj.advanced_setting"
                :key="index"
              >
                <td>
                  <p>{{index+1}}</p>
                </td>
                <td>
                  <p>{{item.scheduleDate}}</p>
                </td>
                <td>
                  <input
                    type="number"
                    v-numeric-only
                    class="inputbox custom-input"
                    :name="'amount'+index"
                    v-model="item.amount"
                  />
                </td>
              </tr>
            </table>
          </div>

          <footer>
            <bottom-action-container>
              <template slot="end">
                <btn-grp class="form-button">
                  <btn text="Cancel" type="secondary" @click="cancelAdvanceSettings" />
                  <btn text="Save" type="primary" @click="saveAdvanceSettings"></btn>
                </btn-grp>
              </template>
            </bottom-action-container>
          </footer>
        </div>
      </div>
    </div>
    -->
    <!-- UAT 169 (When deleting an uploaded file, notification should display asking for confirmation) - 28/11/2019 -->
    <pop-up-message
      v-if="showPopup"
      message="Are you sure you want to delete ?"
      popupType="Warning"
      :popupHeaderMessage="'Confirm Delete'"
      :closable="false"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancelEvent()">Cancel</button>
          <button class="btn-popup" type="button" @click="deleteEvent()">Delete</button>
        </div>
      </template>
    </pop-up-message>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="responseMsg"
      btnText="Back To Employee Dashboard"
      @back="backfrompopup()"
    />
    <pop-up-message
      v-if="showErrorPopup"
      message=""
      popupType="Warning"
      :popupHeaderMessage="'UPLOAD FAILED!!!'"

    >
        <template v-slot:bottomContent>
        <div class=" margintop-32">
          <div class="Rectangle margintop-32">
          <span class="Information-message">This file had errors.</span>
          </div>
          <div class=" margintop-32">
            <span>{{successCount}} Employee records inserted. </span>
            </div>
            <div class=" margintop-32">
            <span>{{invalidCount}} records had incorrect data
               </span>
               <span>(Error records will be ignored. You can continue with rest of the file)</span>
          </div>
          <div class="radio-btn margintop-32">
            <span>{{existingCount}} records already exist. </span>
      <!--  <tl-radio
          name="checkAction"
          label="overwrite"
          id="overwrite"
          value="overwrite"
          v-model="flag"
        />
        <tl-radio
          name="checkAction"
          label="skip"
          id="skip"
          value="skip"
          v-model="flag"
        /> -->
        </div>
    </div>
    <div class="margintop-32 custom-container">
    <a :href="logSheetUrl"
      @click="downloadItem(logSheetUrl)"
    ><img src="@/assets/download.svg"  class="img" /> <span class="text">Error Log Sheet</span></a>
        </div>

        <div class="popup-btn-group margintop-32 marginright">

          <button class="btn-popup" type="button" @click="backfrompopup()">"Back To Employee Dashboard"</button>

         <!-- <button class="btn-popup" type="button" @click="uploadFile2($event)">Proceed</button>
              -->  </div>
      </template>
    </pop-up-message>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { get_axios_file_instance, api_variables } from "@/apis/variables.js";
import * as globalConfig from "@/apis/config.js";
var axios_instance = get_axios_file_instance(api_variables.SERVICE_UPLOAD_LOGO);

export default {
  data() {
    return {
      is_pf_wage_enabled: false,
      phoneNumRegex: null,
      emailRegex: null,
      pincodeRegex: null,
      componentKey: 0,
      pancardRegex: "^[A-Z]{3}[PHAJ]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$",
      ifscRegex: null,
      personalDocument: false,
      proffesionalDocument: false,
      educationalDocument: false,
      communicationAddressDisable:false,
      bulkUploadUrl: api_variables.SERVICE_BULK_UPLOAD_EMPLOYEE,
      employeeTempateUrl: api_variables.SERVICE_EPLOYEE_UPLOAD_TEMPLATE,
      logSheetUrl:null,
      successCount:null,
      invalidCount:null,
      existingCount:null,
      // showEmployeeData: true,
      showPopup: false,
      docIndex: null,
      documentType: "",
      tabs: [
        {
          header: "Personal"
        },
        {
          header: "Professional"
        },
        {
          header: "Educational"
        }
      ],

      employeesubcategoryList_id: "",
      popupType: "Success",
      currentYear: null,
      showSuccessMsg: false,
      showErrorPopup: false,
      responseMsg: "",
      ltaFinancialYearOptions: [],
      error: "",
      errmsg: "",
      blockYears: [
        "1990-1993",
        "1994-1997",
        "1998-2001",
        "2002-2005",
        "2006-2009",
        "2010-2013",
        "2014-2017",
        "2018-2021"
      ],
      maritalStatus: [
        { name: "Single", id: "single" },
        { name: "Married", id: "married" },
        { name: "Divorced", id: "divorcee" },
        { name: "Widowed", id: "widowed" }
      ],
      vasectomySelection: ["Yes", "No"],
      // issue while adding employee - PL-1936  - 29/11/2019
      //Issue UAT_137
      employment_types: [
        { name: "Consultant", value: "Consultant" },
        { name: "Intern", value: "Intern" },
        { name: "Permanent", value: "Permanent" },
        { name: "Contractor", value: "Contractor" }
      ],
        disabilitySelection: [
        { name: "Yes", value: "yes" },
        { name: "No", value: "no" }
      ],
      restrictedWagesEmployee: false,
      nonRestrictedWagesEmployee: false,
      restrictedWagesEmployer: false,
      nonRestrictedWagesEmployer: false,
      contribution_rule: [
        { id: "RESTRICT", name: "Calculate on Restricted PF Wages" },
        { id: "NON_RESTRICT", name: "Calculate on Actual PF Wages" }
      ],
      relationshipList: [
        "Aunt",
        "Brother",
        "Daughter",
        "Father",
        "Grandfather",
        "Grandmother",
        "Guardian",
        "Husband",
        "Mother",
        "Sister",
        "Son",
        "Uncle",
        "Wife"
      ],
      relationship: null,
      banktransfertype: ["NEFT", "RTGS", "IMPS"],

      // Need Cash in Mode of Payment (UAT 165) - 28/11/2019
      modeofpayment: ["Cash", "Cheque", "DD", "Transfer"],
      deductionFrequencyOptions: [
        { name: "Monthly", id: "MONTHLY" },
        { name: "Quarterly", id: "QUARTERLY" },
        { name: "Half Yearly", id: "BI_ANNUALLY" },
        { name: "Yearly", id: "ANNUALLY" }
      ],
      pt_deduction_frequency: null,
      //esi_deduction_frequency: null,
      toast: false,
      uploadMethod: "manualUpload",
      flag:"skip",
      assignedComponentsList: [],
      customEmpList: [],
      employeeObject: {
        id: null,
        name: null,
        code: null,
        email_id: null,
        assignedComponentsList: []
      },
      // new code

      // personal details
      state: [],
      lta_details: [
        {
          blockYear: null,
          ltaFinancialYear: null,
          ltaCompanyName: null,
          ltaAmount: null
        }
      ],
      leave_encashment: [
        {
          leaveFinancialYear: null,
          leaveCompanyName: null,
          leaveAmount: null
        }
      ],
      gratuity_details: [
        {
          slabFinancialYear: null,
          slabCompanyName: null,
          slabAmount: null
        }
      ],
      salaryTableData: [],
      isAllComponentSelected: false,
      udfData: [],
      componentsList: [],
      bankList: [],
      checkboxPT: false,
      payroll_bank_id: null,
      other_bank_id: null,
      fbp_bank_id: null,
      selectedTableData: [],
      state_id: null,
      city_id: null,
      phone_number: "",
      comStateID: {},
      comCityID: null,
      countriesListArray: globalConfig.GlobalList.countriesList,
      country_id: globalConfig.GlobalList.countriesList[0],
      comCountryID: globalConfig.GlobalList.countriesList[0],
      vasectomy: null,
      disability: null,
      employment_type: null,
      managerName: null, // PL_2375
      personal: {
        first_name: null,
        last_name: null,
        username: null,
        father_name: null,
        mother_name: null,
        marital_status: null,
        official_email_id: null,
        photo_url: null,
        code: null,
        phoneNumber: null,
        mobile_number: null,
        dob: null,
        email_id: null,
        pran_number: null,
        pan_number: null,
        adhar_number: null,
        emergency_contact_name: null,
        emergency_contact_number: null,

        permanent_address: {
          addressLineOne: null,
          addressLineTwo: null,
          countryID: null,
          stateID: null,
          stateName: null,
          cityName: null,
          cityID: null,
          pincode: null,
          email: null,
          phoneNumber: null
        },
        communication_address: {
          isSameAsPermanent: false, //PL_2546
          addressLineOne: null,
          addressLineTwo: null,
          countryID: null,
          stateName: null,
          cityName: null,
          stateID: null,
          cityID: null,
          pincode: null,
          email: null,
          phoneNumber: null
        },
        gender: "male",
        employee_tax_status: "nri",
        metro: true,
        enable_fbp_ess: false,
        // is_ess_enable: false
      },
      // official details
      skillList: [
        { name: "Highly skilled", id: "highlyskilled" },
        { name: "Skilled", id: "skilled" },
        { name: "Semi skilled", id: "semiskilled" },
        { name: "Unskilled", id: "unskilled" }
      ],
      skill: null,
      btnText: "",
      showanotheraccount: "",
      costCenterList: [],
      categoryList: [],
      designationList: [],
      levelList:[],
      gradeList: [],
      departmentList: [],
      bandList: [],
      paygroupList: [],
      locationList: [],
      industrytype: [],
      employeesubcategoryList: [],
      band_id: null,
      location_id: null,
      grade_id: null,
      department_id: null,
      designation_id: null,
      level_id: null,
      cost_center_id: null,
      paygroup_id: null,
      official: {
        reporting_manager_id: null,
        is_reporting_manager: false,
        band_id: null,
        band_name: null,
        date_of_joining: null,
        official_email_id: null,
        category_data_json: null,
        category_id: null,
        subcategory: null,
        skill: null,
        based_location_id: null,
        based_location_name: null,
        grade_id: null,
        department_id: null,
        designation_id: null,
        level_id: null,
        cost_center_id: null,
        cost_center_name: null,
        department_name: null,
        designation_name: null,
        grade_name:null,
        level_name: null,
        paygroup_id: null,
        paygroup_name:null,
        legal_entity_id: null,
        disability: null,
        vasectomy: null,
        employment_type: null,
      },

      // salary details

      sendPayslip: false,
      exemptDeduction: true,
      popupMessage: "",
      extendRetDate: false,
      salaryComponentList: [],
      salaryStructureObj: null,
      salary: {
        ctc: null,
        salary_structure_id: null,
        exempt_for_it_deduction_first_month: false,
        master_salary_structure: [],
        salary_effective_date: null,
      },
      salarystructure: [],
      columnNames: [
        {
          label: "Pay Component",
          key: "name"
        },
        {
          label: "Calculation",
          key: "formula"
        },
        {
          label: "Monthly Amount ( in Rupees )",
          key: "monthly"
        },
        {
          label: "Annual Amount ( in Rupees)",
          key: "total"
        },
        {
          label: "",
          key: "isEdited"
        }
      ],
      docscolumnNames: [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "File Name",
          key: "file"
        },
        {
          label: "Action",
          key: ""
        }
      ],
      documentObj: {},
      DocumentData: [],
      locationPT: false,
      ProfessionaldocumentObj: {},
      ProfessionalDocumentData: [],
      educationaldocumentObj: {},
      EducationalDocumentsData: [],
      EmployeeDocsColumns: [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "File",
          key: "location"
        },
        {
          label: "Actions",
          key: "action"
        }
      ],

      // pf_esi details

      minimum_wage_eligible: true,
      lwf: null,
      regType: null,
      minimum_wage_industry_type: "",
      pfesi: {
        pf_enabled: "no",
        uan_number: null,
        pf_number: null,
        pf_enrollment_date: null, // PL_2355
        nomniee_name: null,
        nomniee_dob: null, // PL_2355
        entitled_esi: "no",
        minimum_wage_calculated_on: "BDA",
        relationship: null, // PL_2355
        esi_number: null,
        lwf_applicable: false,
        eps_applicable:false,
        international_employee:false,
        minimum_wage_eligible: false,
        pt_applicable: false,
        pt_state_id: null,
        employeecontributionrule: null,
        employercontributionrule: null,
        pt_deduction_frequency: null, // PL_2355
        minimum_wage_industry_type: null, //PL_2314
        minimum_wage_zone_id: null, //PL_2314
        pf_wage:0,
      },
      navigation: "",
      // bank details
      isJoinComponent: false,
      showbankdetails: true,
      bank: {
        same_acc_fbp: true,
        account_holder_name: null,
        account_number: null,
        account_type: null,
        paymentType: "Cash", // PL_2908
        bank_name: null,
        ifsc_code: null,
        bank_transfer_type: null,
        micr_code: null,
        upi: null,
        branch_name:null,
        fbp: {
          account_holder_name: null,
          account_number: null,
          account_type: null,
          bank_name: null,
          ifsc_code: null,
          bank_transfer_type: null,
          micr_code: null,
          upi: null,
          branch_name:null,
        },
        addbank: {
          account_holder_name: null,
          account_number: null,
          account_type: null,
          bank_name: null,
          ifsc_code: null,
          branch_name:null,
          bank_transfer_type: null,
          micr_code: null,
          credit: null
        }
      },
      nonCtcComponentsList: [],
      ptSatateOptions: [],
      pt_state_id: null,
      minimumWageZoneList: [],
      minimum_wage_zone_id: null,

      assignedComponentsObj: {
        componentObj: null,
        from: null,
        to: null,
        amount: null,
        name: null,
        salary_component_id: null,
        // advanced_setting: [],
        assigned_date: new Date(),
        unassign_date: null
      },
      historyObj: {
        fromMonth: null,
        fromYear: null,
        toMonth: null,
        toYear: null
      },
      isLockList: "No",
      selectedAdvanceSettingsIndex: null,
      openDate: "",
      filteredUdf: [],
      leIncorporationDate: null
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      getleData: "onboard/legal_entities/record",
      getITSettingsData: "onboard/statutoryinfo/incometax/getITData",
      getPfSettingsData: "onboard/statutoryinfo/pfsettings/getPfData"
    }),
    ...mapState({
      orgId: state => state.onboard.organization.id,
      empsubcategory: state => state.onboard.empCategory.data,
      legalEntityData: state => state.onboard.legal_entities.data,
      globalData: state => state.globalapi.globalData.data,
      unsavedEmployeeData: state => state.onboard.employees.unsavedEmployeeData,
      loginId:state=>state.auth.email,
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    showTopBar() {
      if (this.$route.params.step_name == "joinings") {
        return false;
      } else {
        return true;
      }
    }
  },

  mounted() {
    this.getUrl();
    this.salaryTableData = [];
    this.countriesListArray = globalConfig.GlobalList.countriesList;

    this.phoneNumRegex = globalConfig.Regex.PHONE_NUM;
    this.emailRegex = globalConfig.Regex.EMAIL;
    this.pincodeRegex = globalConfig.Regex.PINCODE;
    this.pancardRegex = globalConfig.Regex.EMPLOYEE_PAN;
    this.ifscRegex = globalConfig.Regex.IFSC;
    this.setLegalEntityIncorporationDateValidation();
  },
  activated() {
    this.setDocs();
    let d = new Date();
    this.currentYear = d.getFullYear();
    let d2 = new Date(new Date().setYear(new Date().getFullYear() - 17));
    this.openDate =
      d2.getFullYear() +
      "-" +
      ("0" + (d2.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + d2.getDate()).slice(-2);
    this.toast = false;
    this.isAllComponentSelected = false;
    this.selectedTableData = [];
    // if (
    //   this.legalEntityData[this.$route.params.entity_index] // PL_2397
    //     .autogenerate_employee_code &&
    //   !this.$route.query.id
    // ) {
    //   this.getEmployeeCode();
    // }
    this.setGlobalData();
    this.setLegalEntityIncorporationDateValidation();
    this.getDesignations();
    this.getLevels();
    this.getGrades();
    this.getBands();
    this.getEmpCategoryList();
    this.getDepartments();
    this.getCostCenter();
    this.getPaygroups();
    this.getLocations();
    this.fetchAllSalaryStructureData();
    this.getNonCTCComponents();
    this.fetchUdf();
    this.resetForm();
    this.fetchPfWageData();
    this.salaryTableData = [];
    if (this.isJoinComponent) {
      this.btnText = "Next";
      this.setDefaultSettings(); // PL_2320
    } else {
      if (this.$route.query.id) {
        this.btnText = "Update Employee";
        this.uploadMethod = "manualUpload";
        this.fetchRecord();
      } else {
        this.btnText = "Add Employee";
        this.uploadMethod = "manualUpload";
        if(this.unsavedEmployeeData) this.setRecordData();
        //console.log("this.unsavedEmployeeData : ", this.unsavedEmployeeData);
        this.setDefaultSettings(); // PL_2320
      }
    }
  },
  methods: {
    ...mapActions({
      act_fetchEmpById: "onboard/employees/fetchEmpDataById",
      act_storeUnsavedEmployeeData: "onboard/employees/storeUnsavedEmployeeData",
      fetchEmployeeCode: "onboard/employees/fetchEmployeeCode",
      fetch_grades: "onboard/salary_grades/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_departments: "onboard/departments/fetchAll",
      fetch_template: "onboard/employees/getEmployeeTemplate",
      fetch_cost_center: "onboard/cost_centres/fetchAll",
      fetch_designation: "onboard/designations/fetchAll",
      fetch_level: "onboard/levels/fetchAll",
      fetch_paygroups: "onboard/paygroup/fetchAll",
      fetchEmployeeByName: "globalapi/globalemployees/fetchByNameInCurrentOrg", // PL_2375
      fetch_locations: "onboard/locations/fetchAll",
      fetch_ITSettings: "onboard/statutoryinfo/incometax/fetchAll",
      fetchPf: "onboard/statutoryinfo/pfsettings/fetchAll",
      act_calculat_salary: "onboard/settings/salary_component/calculateSalary",
      act_fetchAll: "onboard/settings/salary_structure/fetchAll",
      act_flagCustomStructure: "onboard/settings/salary_structure/addCustomStructure",
      act_fetchSalaryStructureComponent: "onboard/settings/salary_structure/fetchSalaryStructureComponents",
      act_upload_template: "onboard/employees/uploadTemplate",
      act_download_log_file: "onboard/employees/getUploadErrorLog",
      act_uploadPart:"onboard/employees/uploadPart",
      act_delete: "delete",
      fetch_empCategories: "onboard/empCategory/fetchAll",
      act_fetchsalarycomponents:
        "onboard/settings/salary_component/fetchAllsalaryComponentsData",
      act_update: "onboard/employees/update",
      act_create: "onboard/employees/create",
      act_fetch_nonctc_comp:
        "onboard/employees/fetchAllNonCTCcomponents", //PL_2241
      act_fetchUdf: "onboard/importUdf/fetchAll"

    }),


     async getEmployeeTemplate() {
       //console.log("Inside getEmployeeTemplate");
      try {
        let res = await this.fetch_template(this.le_id);
        //console.log({res});
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** Function to fetch components of a salary structure from server */
    async getSalaryStructureComponent() {
      try {
        let res = await this.act_fetchSalaryStructureComponent({
          id: this.$route.query.id,
          leId: this.leId
        });

        if (res.message != null) {
          throw Error(res.message);
        }
        if (this.$route.query.id) {
          // this.editDefaultSelection();
        }
        // this.salaryStructureDetail = res.data.payload[0];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** PL_2949 */
    setLegalEntityIncorporationDateValidation() {
      try {
        this.leIncorporationDate = this.legalEntityData[
          this.$route.params.entity_index
        ].incorporationDate
          ? this.legalEntityData[this.$route.params.entity_index]
              .incorporationDate
          : null;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** PL_2949 */
    /* function to set status of non ctc salary components */
    getStatus(salaryComponentObj) {
      try {
        let currentDate = new Date();
        let applicable_from = new Date(salaryComponentObj.from);
        let applicable_to = new Date(salaryComponentObj.to);

        if (salaryComponentObj.unassign_date) {
          return "Unassigned";
        } else if (currentDate < applicable_from) {
          return "Scheduled";
        } else if (
          currentDate > applicable_from &&
          currentDate < applicable_to
        ) {
          return "Active";
        } else {
          return "Completed";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    //  start autogenerate_employee_code
    /* server call to genearte employee code based on format entered in Legal Entity form */
    async getEmployeeCode() {
      try {
        let res = await this.fetchEmployeeCode(this.le_id);
        this.personal.code = res.data.payload.data;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    // end autogenerate_employee_code

    /* function to set PF & IT data by default */
    // Start PL_2320
    setDefaultSettings() {
      try {
        if (!this.getITSettingsData[this.le_id]) {
          this.fetchit();
        } else {
          let obj = this.getITSettingsData[this.le_id];
          this.salary.exempt_for_it_deduction_first_month = obj.itSettings
            ? obj.itSettings.exemptForITDeductionFirstMonth
            : false; // PL_2943
        }
        // to set pf details according to legal entity - 21/11/2019
        if (!this.getPfSettingsData[this.le_id]) {
          this.fetchPfData();
        } else {
          let obj = this.getPfSettingsData[this.le_id];
         // this.pfesi.pf_enabled = obj.isApplicable ? "yes" : "no";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    // End PL_2320
    /** On PF Ruke dropdown change */
    onPfRuleChange(event, type) {
      try {
        if (type == "employee") {
          this.employeecontributionrule = event;
          if (event.id == "RESTRICT") {
            this.restrictedWagesEmployee = true;
            this.nonRestrictedWagesEmployee = false;
            this.restrictedWagesEmployer = true;
            this.nonRestrictedWagesEmployer = false;
            this.employercontributionrule = event;
          } else {
            this.restrictedWagesEmployee = false;
            this.nonRestrictedWagesEmployee = true;
            this.restrictedWagesEmployer = false;
            this.nonRestrictedWagesEmployer = true;
            this.employercontributionrule = event; // PL_2056
          }
        } else {
          this.employercontributionrule = event;
          if (event.id == "RESTRICT") {
            this.restrictedWagesEmployer = true;
            this.nonRestrictedWagesEmployer = false;
          } else {
            this.restrictedWagesEmployer = false;
            this.nonRestrictedWagesEmployer = true;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to get documents details list */
    setDocs() {
      try {
        this.DocumentData = [
          {
            name: "Aadhar Card",
            type: "file",
            document_category: "Personal",
            location: null,
            created_by_employee: true,
            created_by: null,
            modified_by_employee: false,
            modified_by: null,
            parent_id: null
          },
          {
            name: "Pan Card",
            type: "file",
            document_category: "Personal",
            location: null,
            created_by_employee: true,
            created_by: null,
            modified_by_employee: false,
            modified_by: null,
            parent_id: null
          },
          {
            name: "Passport",
            type: "file",
            document_category: "Personal",
            location: null,
            created_by_employee: true,
            created_by: null,
            modified_by_employee: false,
            modified_by: null,
            parent_id: null
          },
          {
            name: "Voter Id Card",
            type: "file",
            document_category: "Personal",
            location: null,
            created_by_employee: true,
            created_by: null,
            modified_by_employee: false,
            modified_by: null,
            parent_id: null
          },
          {
            name: "Birth Certificate",
            type: "file",
            document_category: "Personal",
            location: null,
            created_by_employee: true,
            created_by: null,
            modified_by_employee: false,
            modified_by: null,
            parent_id: null
          },
          {
            name: "Marriage Certificate",
            type: "file",
            document_category: "Personal",
            location: null,
            created_by_employee: true,
            created_by: null,
            modified_by_employee: false,
            modified_by: null,
            parent_id: null
          }
        ];
        this.ProfessionalDocumentData = [
          {
            name: "Offer Letter",
            type: "file",
            document_category: "Professional",
            location: null,
            created_by_employee: true,
            created_by: null,
            modified_by_employee: false,
            modified_by: null,
            parent_id: null
          },
          {
            name: "Experience Letter",
            type: "file",
            document_category: "Professional",
            location: null,
            created_by_employee: true,
            created_by: null,
            modified_by_employee: false,
            modified_by: null,
            parent_id: null
          },
          {
            name: "Relieving Letter",
            type: "file",
            document_category: "Professional",
            location: null,
            created_by_employee: true,
            created_by: null,
            modified_by_employee: false,
            modified_by: null,
            parent_id: null
          },
          {
            name: "CV",
            type: "file",
            document_category: "Professional",
            location: null,
            created_by_employee: true,
            created_by: null,
            modified_by_employee: false,
            modified_by: null,
            parent_id: null
          }
        ];
        this.EducationalDocumentsData = [
          {
            name: "10th Certificate",
            type: "file",
            document_category: "Educational",
            location: null,
            created_by_employee: true,
            created_by: null,
            modified_by_employee: false,
            modified_by: null,
            parent_id: null
          },
          {
            name: "12th Certificate",
            type: "file",
            document_category: "Educational",
            location: null,
            created_by_employee: true,
            created_by: null,
            modified_by_employee: false,
            modified_by: null,
            parent_id: null
          },
          {
            name: "Graduation Certificate",
            type: "file",
            document_category: "Educational",
            location: null,
            created_by_employee: true,
            created_by: null,
            modified_by_employee: false,
            modified_by: null,
            parent_id: null
          },
          {
            name: "Masters",
            type: "file",
            document_category: "Educational",
            location: null,
            created_by_employee: true,
            created_by: null,
            modified_by_employee: false,
            modified_by: null,
            parent_id: null
          },
          {
            name: "PHD",
            type: "file",
            document_category: "Educational",
            location: null,
            created_by_employee: true,
            created_by: null,
            modified_by_employee: false,
            modified_by: null,
            parent_id: null
          }
        ];
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to create a custom document row to add in Personal tab */
    createpersonalrow() {
      try {
        this.personalDocument = !this.personalDocument;
        this.documentObj = {
          name: null,
          type: "file",
          document_category: "Personal",
          location: null,
          created_by_employee: true,
          created_by: null,
          modified_by_employee: false,
          modified_by: null,
          parent_id: null
        };
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to add custom documents in Personal tab */
    pushpersonalDocument(document) {
      try {
        this.DocumentData.push(document);
        this.personalDocument = !this.personalDocument;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

/* function to cancel the addition of custom documents in Personal tab */
    cancelpersonalDocument() {
      this.personalDocument = false;
    },

    /* function to create a custom document row to add in Proffesional tab */
    createproffesionalrow() {
      try {
        this.proffesionalDocument = !this.proffesionalDocument;
        this.ProfessionaldocumentObj = {
          name: null,
          type: "file",
          document_category: "Professional",
          location: null,
          created_by_employee: true,
          created_by: null,
          modified_by_employee: false,
          modified_by: null,
          parent_id: null
        };
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to add custom documents in Proffesional tab */
    pushproffesionalDocument(document) {
      try {
        this.ProfessionalDocumentData.push(document);
        this.proffesionalDocument = !this.proffesionalDocument;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
/* function to cancel the addition of custom documents in Proffesional tab */
    cancelproffesionalDocument() {
      this.proffesionalDocument = false;
    },

/* function to create a custom document row to add in Educational tab */
    createEducationrow() {
      try {
        this.educationalDocument = !this.educationalDocument;
        this.educationaldocumentObj = {
          name: null,
          type: "file",
          document_category: "Educational",
          location: null,
          created_by_employee: true,
          created_by: null,
          modified_by_employee: false,
          modified_by: null,
          parent_id: null
        };
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to add custom documents in Educational tab */
    pusheducationalDocument(document) {
      try {
        this.EducationalDocumentsData.push(document);
        this.educationalDocument = !this.educationalDocument;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
/* function to cancel the addition of custom documents in Educational tab */
    canceleducationalDocument() {
      this.educationalDocument = false;
    },

    /* function to set from date */
    fromDateChanged(event) {
      try {
        this.assignedComponentsObj.from = event;
        this.dateRange(
          this.assignedComponentsObj.from,
          this.assignedComponentsObj.to
        );
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },


    /* function to set to date */
    toDateChanged() {
      this.dateRange(
        this.assignedComponentsObj.from,
        this.assignedComponentsObj.to
      );
    },

    /* function to set the date range */
    dateRange(startDate, endDate) {
      try {
        if (startDate && endDate) {
          var start = startDate.split("-");
          var end = endDate.split("-");
          var startYear = Number(start[0]);
          var endYear = Number(end[0]);
          // this.assignedComponentsObj.advanced_setting = [];

          for (var i = startYear; i <= endYear; i++) {
            var endMonth = i != endYear ? 11 : Number(end[1]) - 1;
            var startMon = i === startYear ? Number(start[1]) - 1 : 0;
            for (
              var j = startMon;
              j <= endMonth;
              j = j > 12 ? j % 12 || 11 : j + 1
            ) {
              var month = j + 1;
              var displayMonth = month < 10 ? "0" + month : month;
              // let finalMonth = this.getMonthName(String(displayMonth));

              // let existedObj = this.assignedComponentsObj.advanced_setting.find(
              //   item => item.scheduleDate == [finalMonth, i].join(" ")
              // );
              //
              // let obj = {
              //   amount: existedObj ? existedObj.amount : 0,
              //   scheduleDate: [finalMonth, i].join(" ")
              // };
              //
              // this.assignedComponentsObj.advanced_setting.push(obj);
            }
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* refreshing the particular component*/
    refresh() {
      this.componentKey += 1;
    },

    /* server call to get IT settings for current Legal Entity */
    async fetchit() {
      try {
        let res = await this.fetch_ITSettings(this.le_id);
        if (res.data.status) {
          this.salary.exempt_for_it_deduction_first_month = res.data.payload
            .data.itSettings
            ? res.data.payload.data.itSettings.exemptForITDeductionFirstMonth
            : false;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    // to set pf details according to legal entity - 21/11/2019
    async fetchPfData() {
      try {
        let res = await this.fetchPf(this.le_id);
        if (res.data.status) {
          this.pfesi.pf_enabled = res.data.payload.data.isApplicable
            ? "yes"
            : "no";
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async fetchPfWageData() {
      try {
        let res = await this.fetchPf(this.le_id);
        if (res.data.status) {
          this.is_pf_wage_enabled = res.data.payload.data.enablePFWage;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },


    /* function to cancel the advance setting */
    cancelAdvanceSettings() {
      // this.showEmployeeData = true;
      try {
        if (!this.assignedComponentsObj.id) {
          this.assignedComponentsObj = {
            componentObj: null,
            from: null,
            to: null,
            amount: null,
            // advanced_setting: [],
            name: null,
            salary_component_id: null,
            assigned_date: new Date(),
            unassign_date: null
          };
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to save advance settings for the nonctc component */
    saveAdvanceSettings() {
      // this.showEmployeeData = true;
      try {
        this.assignedComponentsList[
          this.selectedAdvanceSettingsIndex
        ].componentObj = this.assignedComponentsObj.componentObj;
        this.assignedComponentsList[
          this.selectedAdvanceSettingsIndex
        ].salary_component_id = this.assignedComponentsObj.componentObj.id;
        this.assignedComponentsList[
          this.selectedAdvanceSettingsIndex
        ].salary_component_code = this.assignedComponentsObj.componentObj.code;
        this.assignedComponentsList[
          this.selectedAdvanceSettingsIndex
        ].from = this.assignedComponentsObj.from;
        this.assignedComponentsList[
          this.selectedAdvanceSettingsIndex
        ].to = this.assignedComponentsObj.to;
        // this.assignedComponentsList[
        //   this.selectedAdvanceSettingsIndex
        // ].advance_setting = this.assignedComponentsObj.advanced_setting;
        this.assignedComponentsList[
          this.selectedAdvanceSettingsIndex
        ].assigned_date = this.assignedComponentsObj.assigned_date;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to set assigned component */
    nonctcadvancesetting(event, index) {
      try {
        this.monthsArray = [];
        // this.showEmployeeData = false;
        this.selectedAdvanceSettingsIndex = index;
        if (
          !(
            this.assignedComponentsList[index].advance_setting &&
            this.assignedComponentsList[index].advance_setting.length
          )
        ) {
          this.assignedComponentsObj = {
            componentObj: event.componentObj ? event.componentObj : null,
            from: event.from ? event.from : null,
            to: event.to ? event.to : null,
            amount: event.value,
            // advanced_setting: event.advanced_setting
            //   ? event.advanced_setting
            //   : [],
            name: null,
            salary_component_id: event.salary_component_id
              ? event.salary_component_id
              : null,
            assigned_date: new Date(),
            unassign_date: event.unassign_date ? event.unassign_date : null
          };
        } else {
          this.assignedComponentsObj = {
            id: event.id,
            componentObj: event.componentObj ? event.componentObj : null,
            from: event.from ? event.from : null,
            to: event.to ? event.to : null,
            // advanced_setting: event.advanced_setting
            //   ? event.advanced_setting
            //   : [],
            amount: event.amount,
            name: event.name ? event.name : null,
            salary_component_id: event.salary_component_id
              ? event.salary_component_id
              : null,
            assigned_date: new Date(),
            unassign_date: event.unassign_date ? event.unassign_date : null
          };
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get non ctc components for current Legal Entity*/
    async getNonCTCComponents() {
      try {
        let res = await this.act_fetch_nonctc_comp(this.le_id);
        if (res.data.status) {
          this.nonCtcComponentsList = res.data.payload.data;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to upload a file in document details section */
    uploadFile(event, propsValue, type) {
      this.uploadFileToServer(event, propsValue.index, type);
    },

    /* server call to upload a file */
    async uploadFileToServer(docFile, index, type) {
      try {
        if (docFile)
          if (docFile.size > Number(this.maxSize)) {
            this.$emit("bigFileSize");
          } else {
            this.file = docFile;
            let formData = new FormData();
            formData.append("file", docFile);
            // multipart
            let res = await axios_instance.post("", formData);
            if (res.data.status) {
              if (type == "PERSONNEL") {
                document.getElementById("file_PERSONNEL" + index).value = null; // to clear upload event - 29/11/2019
                this.DocumentData[index].location = res.data.location;
              } else if (type == "PROFESSIONAL") {
                document.getElementById(
                  "file_PROFESSIONAL" + index
                ).value = null; // to clear upload event - 29/11/2019
                this.ProfessionalDocumentData[index].location =
                  res.data.location;
              } else if (type == "EDUCATIONAL") {
                document.getElementById(
                  "file_EDUCATIONAL" + index
                ).value = null; // to clear upload event - 29/11/2019
                this.EducationalDocumentsData[index].location =
                  res.data.location;
              }
            }
          }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    // UAT 169 (When deleting an uploaded file, notification should display asking for confirmation) - 28/11/2019
    cancelEvent() {
      this.showPopup = false;
    },

    /* function to confirm to delete an uploaded file */
    deleteEvent() {
      try {
        if (this.documentType == "personal") {
          this.DocumentData[this.docIndex].location = null;
        }
        if (this.documentType == "professional") {
          this.ProfessionalDocumentData[this.docIndex].location = null;
        }
        if (this.documentType == "educational") {
          this.EducationalDocumentsData[this.docIndex].location = null;
        }
        this.showPopup = false;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },


    /* function to open confirmation pop-up to delete an uploaded file */
    deleteDocumentFile(propsValue, type) {
      try {
        this.showPopup = true;
        this.documentType = type;
        this.docIndex = propsValue.index;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    // end of issue UAT 169
    /* function to set employeesubcategoryList of selected employee category */
    categoryChange(event) {
      try {
        this.official.category_data_json = event;
        this.employeesubcategoryList = event
          ? event.subCategory
            ? event.subCategory
            : []
          : [];
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to select reporting manager after getting search result */
    empselected(val) {
      try {
        this.official.reporting_manager_id = val.id;
        this.managerName = val.first_name + " " + val.last_name;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /* function to generate financial years after selecting block year in Previous employer details section*/
    // PL_2769
    getFinancialYear(val) {
      try {
        let tempArr = val.split("-");
        let startYear = Number(tempArr[0]);
        let endYear = Number(tempArr[1]);
        this.ltaFinancialYearOptions = [];
        let d = new Date();
        for (let i = startYear; i <= endYear; i++) {
          if (d.getMonth() < 3) {
            if (i <= d.getFullYear() - 1) {
              this.ltaFinancialYearOptions.push(i + "");
            }
          } else if (i <= d.getFullYear()) {
            this.ltaFinancialYearOptions.push(i + "");
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to upload excel file for bulk upload*/
     async onUploadTemplate(res) {
      if (res.data.statusCode == 200) {
        this.showSuccessMsg = true; // PL_2363
        this.showErrorPopup = false;
        this.responseMsg = res.data.message ? res.data.message : ""; // PL_2363
      } else if(res.data.status != 200){
            this.logSheetUrl = res.data.payload.logmessages[0].link;
            this.successCount = res.data.payload.logmessages[1].employeeInserted;
            this.invalidCount = res.data.payload.logmessages[2].invalidEmployee;
            this.existingCount = res.data.payload.logmessages[3].employeeAlreadyExist;
            this.showErrorPopup = true;
            // this.toast = true;
            // this.errmsg = res.message;
            // await this.act_download_log_file(this.logSheetUrl);
      }
    },
    
       async onUploadTemplateFailed(res) {
        if (res.response.data.statusCode!= 200) {
            this.toast = true;
            this.errmsg= res.response.data.message;
        }
     },

    /* function to add new row in Gratuity details */
    addGratuityObj() {
      try {
        let newObj = {
          slabFinancialYear: null,
          slabCompanyName: null,
          slabAmount: null
        };
        this.gratuity_details.push(newObj);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to delete a row from Gratuity Details */
    deleteGratuity(index) {
      try {
        this.gratuity_details.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

/* function to add new row in Leave Encashment details */
    leaveEncashment() {
      try {
        let newObj = {
          leaveFinancialYear: null,
          leaveCompanyName: null,
          leaveAmount: null
        };
        this.leave_encashment.push(newObj);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to delete a row from Leave encashment Details */
    deleteLeaveEnc(index) {
      try {
        this.leave_encashment.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to add new row in LTA details */
    getltaDetails() {
      try {
        let newObj = {
          blockYear: null,
          ltaFinancialYear: null,
          ltaCompanyName: null,
          ltaAmount: null
        };
        this.lta_details.push(newObj);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to delete a row from LTA details */
    deleteLTADetails(index) {
      try {
        this.lta_details.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

/* function to set Same FBP account as general account after checking or unchecking the checkbox */
    setFbpAsSame() {
      try {
        if (this.bank.same_acc_fbp) {
          this.bank.fbp.account_holder_name = this.bank.account_holder_name;
          this.bank.fbp.account_number = this.bank.account_number;
          this.bank.fbp.account_type = this.bank.account_type;
          this.bank.fbp.paymentType = this.bank.paymentType;
          this.bank.fbp.bank_name = this.bank.bank_name;
          this.bank.fbp.ifsc_code = this.bank.ifsc_code;
          this.bank.fbp.branch_name = this.bank.branch_name;
          this.bank.fbp.bank_transfer_type = this.bank.bank_transfer_type;
          this.bank.fbp.micr_code = this.bank.micr_code;
          this.bank.fbp.upi = this.bank.upi;
          this.fbp_bank_id = this.payroll_bank_id;
        } else {
          this.bank.fbp.account_holder_name = null;
          this.bank.fbp.account_number = null;
          this.bank.fbp.account_type = null;
          this.bank.fbp.paymentType = null;
          this.bank.fbp.bank_name = null;
          this.bank.fbp.ifsc_code = null;
          this.bank.branch_name = null;
          this.bank.fbp.bank_transfer_type = null;
          this.bank.fbp.micr_code = null;
          this.bank.fbp.upi = null;
          this.fbp_bank_id = null;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

  /* server call to search employees in the organisation after entering name for reporting manager */
    async getEmployeesByName(val) {
      try {
        // PL_3023
        let res = await this.fetchEmployeeByName({
          searchkey: val,
          org_id: this.orgId
        });
        if (res.data.status) {
          this.customEmpList = res.data.payload;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to add new row to add non-ctc salary component */
    addNonCTCcomponent() {
      try {
        let obj = {
          legal_entity_id: this.le_id,
          salary_component_id: null,
          salary_component_code: null,
          // advance_setting: [],
          value: null,
          from: null,
          to: null,
          assigned_date: new Date(),
          componentObj: null
        };
        this.assignedComponentsList.push(obj);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to delete a row in non-ctc salary components table */
    deleteRecord(index) {
      this.assignedComponentsList.splice(index, 1);
    },

    /* function to show other account fields in Bank details after clicking on button 'Add Another Account' */
    addanotheraccount() {
      this.showanotheraccount = true;
    },

    /* function to hide other account fields in Bank details after clicking on button 'Delete Account' */
    deleteAccount() {
      try {
        this.showanotheraccount = false;
        this.other_bank_id = null;
        this.bank.addbank = {
          account_holder_name: null,
          account_number: null,
          account_type: null,
          paymentType: null,
          bank_name: null,
          ifsc_code: null,
          branch_name:null,
          bank_transfer_type: null,
          micr_code: null,
          credit: null
        };
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to set data after changing or selecting the non-ctc salary components */
    componentChanged(event, index) {
      try {
        if (index > -1) {
          this.assignedComponentsList[index].componentObj = event;
          this.assignedComponentsList[index].salary_component_id = event.id;
          this.assignedComponentsList[index].salary_component_code = event.code;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to back from popup after bulk upload success */
    back() {
      this.showBulkUploadSuccessMsg = false;
    },
    /* function to set drop down list from global data */
    setGlobalData() {
      try {
        let obj = this.globalData;
        this.state = obj ? (obj.State ? obj.State : []) : [];
        this.bankList = obj ? (obj.Bank ? obj.Bank : []) : [];
        this.industrytype = obj
          ? obj.IndustryType
            ? obj.IndustryType
            : []
          : [];
        this.ptSatateOptions = obj ? (obj.PTState ? obj.PTState : []) : [];
        this.minimumWageZoneList = obj
          ? obj.MinimumWageZone
            ? obj.MinimumWageZone
            : []
          : [];
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* submiting employee data from new Joinee page in Payroll wizard */
    addEmployee() {
      this.submitForm("nonavigate");
    },

    /* function to set value of isJoinComponent if it is coming from new Joinee page in Payroll wizard*/
    getUrl() {
      this.isJoinComponent =
        this.$route.path.split("/")[this.$route.path.split("/").length - 1] ==
        "joinings";
    },
    /* to lock the onboading of employees in Payroll wizard from new Joinee page */
    locklist(ee) {
      try {
        if (ee) {
          this.isLockList = "Yes";
        } else {
          this.isLockList = "No";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* navigation to add salary structure page to add new salary structure */
    async addSalaryStructure() {
      this.storeEmpData();
      await this.act_flagCustomStructure(true);
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/preferences/addStructure`
      });
    },

    // set form data when navigated back from salary structure
    setRecordData() {
        let employeeObj = this.unsavedEmployeeData;
        this.setPersonalData(employeeObj.personal);
        this.setOfficialData(employeeObj.official);
        this.setSalaryData(employeeObj.salary);
        this.setNonCtc(employeeObj.nonCTC);
        this.setBankdata(employeeObj.bank);
        this.setemployerdetails(employeeObj.employeePreviousEmployer);
        this.setPFESIData(employeeObj.pfesi);
        this.setDocuementDetails(employeeObj.EmployeeDocument);
        this.setUdfData(employeeObj.udf);
    },

    /* server call to get employee's onboarding details */
    async fetchRecord() {
      try {
        let requestPayload = {
          empLeId : this.le_id,
          empId :this.$route.query.id
        }
        let res = await this.act_fetchEmpById(requestPayload);
        let employeeObj = res.data.payload.data;
        setTimeout(() => {
          this.setPersonalData(employeeObj);
          this.setOfficialData(employeeObj.EmployeeOfficial);
          this.setSalaryData(employeeObj.EmployeeSalarySetting[0]);
          this.setNonCtc(employeeObj.EmployeeFixedNonCTCComponent);
          this.setBankdata(employeeObj.EmployeeBankAccount[0]);
          this.setemployerdetails(employeeObj.EmployeePreviousEmployer);
          this.setPFESIData(employeeObj.EmployeePfEsi[0]);
          this.setDocuementDetails(employeeObj.EmployeeDocument);
          this.setUdfData(employeeObj.EmployeeUserDefineField);
        }, 200);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /* function to set Personal data while editing an employee */
    setPersonalData(Obj) {
      try {
        this.personal.code = Obj.code;
        this.personal.first_name = Obj.first_name;
        this.personal.last_name = Obj.last_name;
        this.personal.username = Obj.username;
        this.personal.father_name = Obj.father_name;
        this.personal.mother_name = Obj.mother_name;
        this.personal.name = Obj.first_name;
        this.personal.photo_url = Obj.photo_url; // PL_2013
        this.personal.marital_status = Obj.marital_status;
        this.personal.phoneNumber = Obj.phoneNumber;
        this.personal.mobile_number = Obj.mobile_number;
        this.personal.email_id = Obj.email_id;
        this.personal.dob = Obj.dob;
        this.personal.gender = Obj.gender;
        this.personal.emergency_contact_name = Obj.emergency_contact_name;
        this.personal.emergency_contact_number = Obj.emergency_contact_number;
        this.personal.employee_tax_status = Obj.employee_tax_status;
        this.personal.metro = Obj.metro == true ? true: false;
        this.personal.permanent_address = Obj.permanent_address;
        this.personal.communication_address = Obj.communication_address;
        // start checkbox_issue
        this.personal.communication_address.isSameAsPermanent =
          Obj.communication_address.isSameAsPermanent; // PL_2546
           if (this.personal.communication_address.isSameAsPermanent) {
                       this.communicationAddressDisable=true;
                       this.personal.communication_address = this.personal.permanent_address;
          } else {
                                  this.communicationAddressDisable=false;

          }
        // end checkbox_issue
        this.country_id = this.countriesListArray[0]; // country issue
        this.comCountryID = this.countriesListArray[0]; // country issue
        if (Obj.permanent_address.stateID) {
          this.state_id = this.state.find(
            item => item.id == Obj.permanent_address.stateID
          );
        } else {
          this.state_id = null;
        }
        this.city_id = this.state_id
          ? this.state_id.City.find(
              item => item.id == Obj.permanent_address.cityID
            )
          : null;
        this.comStateID = this.state.find(
          item => item.id == Obj.communication_address.stateID
        );
        this.comCityID = this.comStateID
          ? this.comStateID.City.find(
              item => item.id == Obj.communication_address.cityID
            )
          : null;
        this.personal.pan_number = Obj.pan_number;
        this.personal.adhar_number = Obj.adhar_number;
        this.personal.pran_number = Obj.pran_number;
        this.personal.email = Obj.email;
        this.personal.phoneNumber = Obj.phoneNumber;
        this.personal.enable_fbp_ess = Obj.enable_fbp_ess;
        // this.personal.is_ess_enable = Obj.is_ess_enable;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /* function to set Official data while editing an employee */
    async setOfficialData(Obj) {
      console.log("setOfficialData", Obj);
      try {
        this.official.band_id = Obj.band_id;
        this.official.band_name = Obj.band_name;
        this.band_name = this.bandList.find(item => item.name == Obj.band_name);
        if (this.band_name) {
          this.filterUdf("Salary Band", this.band_name); // PL_2934
        }
        this.band_id = this.bandList.find(item => item.id == Obj.band_id);
        if (this.band_id) {
          this.filterUdf("Salary Band", this.band_id); // PL_2934
        }
        this.official.date_of_joining = Obj.date_of_joining;
        this.official.official_email_id = Obj.official_email_id;
        this.official.category_id = Obj.category_id;
        this.official.category_data_json = this.categoryList.find(
          item => item.id == Obj.category_id
        );
        if (this.official.category_data_json) {
          this.filterUdf(
            "Employee Categories & Sub Categories",
            this.official.category_data_json // PL_2934
          );
        }
        // Start PL_2354
        if (
          this.official.category_data_json &&
          this.official.category_data_json.subCategory
        ) {
          this.employeesubcategoryList_id = this.official.category_data_json.subCategory.find(
            item => item.name == Obj.subcategory
          );
        }
        // End PL_2354
        this.skill = this.skillList.find(item => item.id == Obj.skill);
        this.official.skill = Obj.skill;
        this.official.legal_entity_id = Obj.legal_entity_id;
        this.official.based_location_id = Obj.based_location_id;
        this.official.based_location_name = Obj.based_location_name
        this.location_name = this.locationList.find(
          item => item.name == Obj.based_location_name
        );
        if (this.location_name) {
          this.filterUdf("Location", this.location_name); // PL_2934
        }
        this.location_id = this.locationList.find(
          item => item.id == Obj.based_location_id
        );
        if (this.location_id) {
          this.filterUdf("Location", this.location_id); // PL_2934
        }
        this.official.cost_center_id = Obj.cost_center_id;
        this.official.cost_center_name = Obj.cost_center_name;
        this.cost_center_name= this.costCenterList.find(
          item => item.name == Obj.cost_center_name
        );
        if (this.cost_center_name) {
          this.filterUdf("Cost Centre", this.cost_center_name); // PL_2934
        }
        this.cost_center_id = this.costCenterList.find(
          item => item.id == Obj.cost_center_id
        );
        if (this.cost_center_id) {
          this.filterUdf("Cost Centre", this.cost_center_id); // PL_2934
        }
        this.official.grade_id = Obj.grade_id;
        this.official.grade_name = Obj.grade_name;
        this.grade_name = this.gradeList.find(item => item.name == Obj.grade_name);
        if (this.grade_name) {
          this.filterUdf("Grade", this.grade_name); // PL_2934
        }
        this.grade_id = this.gradeList.find(item => item.id == Obj.grade_id);
        if (this.grade_id) {
          this.filterUdf("Grade", this.grade_id); // PL_2934
        }
        this.official.department_id = Obj.department_id;
        this.official.department_name = Obj.department_name;
        this.department_name = this.departmentList.find(
          item => item.name == Obj.department_name
        );
        if (this.department_name) {
          this.filterUdf("Department", this.department_name); // PL_2934
        }
        this.department_id = this.departmentList.find(
          item => item.id == Obj.department_id
        );
        if (this.department_id) {
          this.filterUdf("Department", this.department_id); // PL_2934
        }
        this.official.designation_id = Obj.designation_id;
        this.official.designation_name = Obj.designation_name;
        this.designation_name= this.designationList.find(
          item => item.name == Obj.designation_name
        );
        this.designation_id = this.designationList.find(
          item => item.id == Obj.designation_id
        );
        this.official.level_id = Obj.level_id;
        this.official.level_name = Obj.level_name;
        this.level_name= this.levelList.find(
          item => item.name == Obj.level_name
        );
        this.level_id = this.levelList.find(
          item => item.id == Obj.level_id
        );
        this.official.paygroup_id = Obj.paygroup_id;
        this.official.paygroup_name = Obj.paygroup_name;
        this.paygroup_name = this.paygroupList.find(
          item => item.name == Obj.paygroup_name
        );
        this.paygroup_id = this.paygroupList.find(
          item => item.id == Obj.paygroup_id
        );
        // issue while adding employee - PL-1936  - 29/11/2019
        this.official.disability = Obj.disability;
        this.disability = this.disabilitySelection.find(
          item => item.value == Obj.disability
        );

         this.official.employment_type = Obj.employment_type;
        this.employment_type = this.employment_types.find(
          item => item.value == Obj.employment_type
        );
        this.official.vasectomy = Obj.vasectomy;
        this.vasectomy = Obj.vasectomy ? "Yes" : "No";
        // Start PL_2375
        if (Obj.reporting_manager_id) {
          let payload ={
          empId:Obj.reporting_manager_id,
          empLeId:this.le_id
          }
          let res = await this.act_fetchEmpById(payload);
          let reportingManager = res.data.payload.data;
          // this.official.reporting_manager_id = Obj.reporting_manager_id;
          // this.getEmployeesByName("");
          this.empselected(reportingManager);
          reportingManager.first_name = reportingManager.first_name == null ? '' : reportingManager.first_name;
          reportingManager.last_name = reportingManager.last_name == null ? '' : reportingManager.last_name;
          this.managerName = reportingManager.first_name + ' ' + reportingManager.last_name;
          this.$refs.search.searchKey = this.managerName;
        }
        // End PL_2375

        // Start PL_3384 changes by Bhushan
          this.official.is_reporting_manager = Obj.is_reporting_manager? true : false;
        // End PL_PL_3384
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to set Previous employer details data while editing an employee */
    setemployerdetails(Obj) {
      try {
        if (Obj && Obj.length) {
          this.gratuity_details = [];
          this.leave_encashment = [];
          this.lta_details = [];
          Obj.forEach(element => {
            if (element.details.name == "gratuity_details") {
              this.gratuity_details.push({
                employee_id: element.employee_id,
                id: element.id,
                slabFinancialYear: element.financial_year
                  ? new Date(element.financial_year, 0, 15)
                  : null, // PL_2535
                slabCompanyName: element.details.company_name,
                slabAmount: element.details.amount
              });
            } else if (element.details.name == "leave_encashment") {
              this.leave_encashment.push({
                employee_id: element.employee_id,
                id: element.id,
                leaveFinancialYear: element.financial_year
                  ? new Date(element.financial_year, 0, 15)
                  : null, // PL_2535
                leaveCompanyName: element.details.company_name,
                leaveAmount: element.details.amount
              });
            } else if (element.details.name == "lta_details") {
              this.lta_details.push({
                employee_id: element.employee_id,
                id: element.id,
                blockYear: element.details.blockYear,
                ltaFinancialYear: element.financial_year,
                ltaCompanyName: element.details.company_name,
                ltaAmount: element.details.amount
              });
            }
          });
        }
      } catch (error) {
        this.toast = true;
        //console.log({error});
        this.errmsg = error;
      }
    },

    /* function to set Salary details data while editing an employee */
    setSalaryData(Obj) {
      try {
        if (Obj) {
          this.salaryStructureObj = this.salarystructure.find(
            item => item.id == Obj.salary_structure_id
          );

          //console.log({ Obj });
          //console.log("this.salaryStructureObj ", this.salaryStructureObj);
          this.salary.ctc = Obj.ctc;
          this.salary.exempt_for_it_deduction_first_month =
            Obj.exempt_for_it_deduction_first_month;
          this.salary.master_salary_structure = Obj.master_salary_structure;
          this.selectedTableData = Obj.master_salary_structure;
          this.fetchAllSalarycomponentsData(
            this.salaryStructureObj.sssc,
            Obj.salary_structure_id
          );
          if(Obj.salary_effective_date){
            this.salary.salary_effective_date = Obj.salary_effective_date
          }else{
            this.salary.salary_effective_date = null;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /* function to set Non-CTC salary data while editing an employee */
    setNonCtc(nonCtcList) {
      try {
        this.assignedComponentsList = nonCtcList;
        this.assignedComponentsList.forEach(element => {
          element["componentObj"] = this.nonCtcComponentsList.find(
            item => item.id == element.salary_component_id
          );
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to set PF, ESI, LWF, PT & Minimum wagw zone data while editing an employee */
    setPFESIData(Obj) {
      try {
        if (Obj) {
            this.pfesi.pf_enabled = Obj.pf_enabled ? "yes" : "no";
          this.pfesi.entitled_esi = Obj.entitled_esi ? "yes" : "no";
          this.pfesi.pf_number = Obj.pf_number;
          this.pfesi.pf_wage = Obj.pf_wage;
          this.pfesi.nomniee_name = Obj.nomniee_name;
          this.pfesi.uan_number = Obj.uan_number; //PL_2018
          this.pfesi.nomniee_dob = Obj.nomniee_dob;
          this.pfesi.lwf_applicable = Obj.lwf_applicable;
          this.pfesi.eps_applicable=Obj.eps_applicable;
          this.pfesi.international_employee=Obj.international_employee;
          this.pfesi.employeecontributionrule = Obj.employeecontributionrule;
          this.employeecontributionrule = this.contribution_rule.find(
            item => item.id == Obj.employeecontributionrule
          );
          this.pfesi.employercontributionrule = Obj.employercontributionrule;
          this.employercontributionrule = this.contribution_rule.find(
            item => item.id == Obj.employercontributionrule
          );
          // pf enrolment date issue - 02/12/2019
          setTimeout(() => {
            this.pfesi.pf_enrollment_date = Obj.pf_enrollment_date;
          }, 500);
          this.pfesi.pt_deduction_frequency = Obj.pt_deduction_frequency; //PL_2019
          this.pt_deduction_frequency = this.deductionFrequencyOptions.find(
            item => item.id == Obj.pt_deduction_frequency
          ); // PL-1938 - 29/11/2019
          this.pfesi.pt_applicable = Obj.pt_applicable;
          this.pfesi.pt_state_id = Obj.pt_state_id;
          this.pt_state_id = this.ptSatateOptions.find(
            item => item.id == Obj.pt_state_id
          ); // PL-1938 - 29/11/2019, PL_2026 - 05/12/2019
          this.pfesi.relationship = Obj.relationship;
          this.relationship = Obj.relationship;
          this.pfesi.esi_number = Obj.esi_number;
          // this.pfesi.minimum_wage_eligible = Obj.minimum_wage_eligible;
          this.pfesi.minimum_wage_calculated_on =
            Obj.minimum_wage_calculated_on;
          this.pfesi.minimum_wage_industry_type =
            Obj.minimum_wage_industry_type;
          this.minimum_wage_industry_type = this.industrytype.find(
            item => item.id == Obj.minimum_wage_industry_type
          ); // PL-1938 - 29/11/2019
          this.pfesi.minimum_wage_zone_id = Obj.minimum_wage_zone_id;
          this.minimum_wage_zone_id = this.minimumWageZoneList.find(
            item => item.id == Obj.minimum_wage_zone_id
          ); // PL-1938 - 29/11/2019
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to set Bank details while editing an employee */
    setBankdata(Obj) {
      try {
        let payrollAccObj = Obj.accounts.find(item => item.type == "ACCOUNT");
        let fbpAccObj = Obj.accounts.find(item => item.type == "FBP");
        let otherAccObj = Obj.accounts.find(item => item.type == "OTHER");

        let noTypeObj = Obj.accounts.find(item => item.type == undefined);
        if(noTypeObj) {
          this.bank.paymentType = noTypeObj.paymentType;
          this.bank.bank_name = noTypeObj.bank_name;
          this.bank.ifsc_code = noTypeObj.ifsc_code;
          this.bank.branch_name = noTypeObj.branch_name;
          this.bank.account_number = noTypeObj.account_number;
          this.bank.account_holder_name = noTypeObj.account_holder_name;
          this.bank.account_type = noTypeObj.account_type;
          this.bank.bank_transfer_type = noTypeObj.bank_transfer_type;
          this.bank.micr_code = noTypeObj.micr_code;
          this.bank.upi = noTypeObj.upi;
          this.payroll_bank_id = this.bankList.find(
            item => item.id == noTypeObj.bank_id
          );
        }

        if (otherAccObj && otherAccObj.account_number) {
          this.showanotheraccount = true;
          this.bank.addbank = otherAccObj;
          this.other_bank_id = this.bankList.find(
            item => item.id == this.bank.addbank.bank_name // PL_2955
          );
        }
        if (payrollAccObj) {
          if (
            fbpAccObj &&
            payrollAccObj.account_number == fbpAccObj.account_number
          ) {
            this.bank.same_acc_fbp = true;
          } else {
            this.bank.same_acc_fbp = false;
          }
          this.bank.account_holder_name = payrollAccObj.account_holder_name;
          this.bank.account_number = payrollAccObj.account_number;
          this.bank.account_type = payrollAccObj.account_type;
          this.bank.paymentType = payrollAccObj.paymentType;
          this.bank.bank_name = payrollAccObj.bank_name;
          this.payroll_bank_id = this.bankList.find(
            item => item.id == this.bank.bank_name
          );
          this.bank.ifsc_code = payrollAccObj.ifsc_code;
          this.bank.branch_name = payrollAccObj.branch_name;
          this.bank.bank_transfer_type = payrollAccObj.bank_transfer_type;
          this.bank.micr_code = payrollAccObj.micr_code;
          this.bank.upi = payrollAccObj.upi;
        }

        if (fbpAccObj) {
          this.bank.fbp = {
            account_holder_name: fbpAccObj.account_holder_name,
            account_number: fbpAccObj.account_number,
            account_type: fbpAccObj.account_type,
            bank_name: fbpAccObj.bank_name,
            paymentType: fbpAccObj.paymentType,
            ifsc_code: fbpAccObj.ifsc_code,
            branch_name: fbpAccObj.branch_name,
            bank_transfer_type: fbpAccObj.bank_transfer_type,
            micr_code: fbpAccObj.micr_code,
            upi: fbpAccObj.upi
          };
          this.fbp_bank_id = this.bankList.find(
            item => item.id == this.bank.fbp.bank_name // PL_2955
          );
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /* function to set Documents details data while editing an employee */
    setDocuementDetails(Obj) {
      try {
        if (Obj && Obj.length) {
          Obj.forEach(element => {
            if (element.document_category == "Personal") {
              let docIndex1 = this.DocumentData.findIndex(
                item => item.name == element.name
              );
              if (docIndex1 > -1) {
                this.DocumentData[docIndex1].location = element.location;
                this.DocumentData[docIndex1]["id"] = element.id;
              } else {
                this.DocumentData.push(element);
              }
            } else if (element.document_category == "Professional") {
              let docIndex2 = this.ProfessionalDocumentData.findIndex(
                item => item.name == element.name
              );
              if (docIndex2 > -1) {
                this.ProfessionalDocumentData[docIndex2].location =
                  element.location;
                this.ProfessionalDocumentData[docIndex2]["id"] = element.id;
              } else {
                this.ProfessionalDocumentData.push(element);
              }
            } else {
              let docIndex3 = this.EducationalDocumentsData.findIndex(
                item => item.name == element.name
              );
              if (docIndex3 > -1) {
                this.EducationalDocumentsData[docIndex3].location =
                  element.location;
                this.EducationalDocumentsData[docIndex3]["id"] = element.id;
              } else {
                this.ProfessionalDocumentData.push(element);
              }
            }
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to set UDF data while editing an employee */
    setUdfData(udfArray) {
      try {
        if (udfArray && udfArray.length) {
          udfArray.forEach(element => {
            let index = this.filteredUdf.findIndex(
              item => item.field_name == element.field_name
            );
            if (index > -1) {
              this.filteredUdf[index] = element;
            }
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to set ESI, PT, LWF & Minimum wage zone after selection Location in Employee Official Details section */
    setLWF_PT_ESI_MWZ() {
      try {
        if (this.location_id.lwf_applicable) {
          this.pfesi.lwf_applicable = true;
        }
        if (this.location_id.esiApplicable) {
          this.pfesi.entitled_esi = "yes";
        } else {
          this.pfesi.entitled_esi = "no";
        }
        if (this.location_id.industry_type) {
          this.minimum_wage_industry_type = this.industrytype.find(
            item => item.id == this.location_id.industry_type
          );
          this.pfesi.minimum_wage_industry_type = this
            .minimum_wage_industry_type
            ? this.minimum_wage_industry_type.id
            : null;
        }
        if (this.location_id.pt_applicable) {
          this.pfesi.pt_applicable = true;
          this.pt_deduction_frequency = this.deductionFrequencyOptions.find(
            item => item.id == this.location_id.pt_deduction_frequency
          );
          this.pfesi.pt_deduction_frequency = this.location_id.pt_deduction_frequency; //PL_2019
          this.pt_state_id = this.location_id.ptState;
          this.pfesi.pt_state_id = this.location_id.ptStateID;
        }
        if(this.location_id.pt_applicable){
          this.locationPT = false;
          this.checkboxPT = true;
        }else{
          this.locationPT = true;
          this.checkboxPT = false;
          this.pfesi.pt_applicable = null;
        }
        // if (this.location_id.minimumWageZoneID) {
        //   this.pfesi.minimum_wage_eligible = true;
        //   this.minimum_wage_zone_id = this.location_id.MinimumWageZone;
        //   this.pfesi.minimum_wage_zone_id = this.location_id.minimumWageZoneID
        //     ? this.location_id.minimumWageZoneID
        //     : null; // minimum wage zone issue
        //   this.pfesi.minimum_wage_calculated_on = this.location_id.minimumWageSalaryType;
        // }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /* funcion to delete employee photo */
    deletePhoto() {
      this.personal.photo_url = null;
    },
    // dropdowns


    /* server call to get Salary Grade list for the current Legal Entity */
    async getGrades() {
      try {
        let res = await this.fetch_grades(this.le_id);
        if (res.data.status) {
          this.gradeList = res.data.payload.data;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* server call to get Location list for the current Legal Entity */
    async getLocations() {
      try {
        let res = await this.fetch_locations(this.le_id);
        if (res.data.status) {
          this.locationList = res.data.payload.data;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* server call to get Salary Band list for the current Legal Entity */
    async getBands() {
      try {
        let res = await this.fetch_bands(this.le_id);
        if (res.data.status) {
          this.bandList = res.data.payload.data;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* server call to get Paygroup list for the current Legal Entity */
    async getPaygroups() {
      try {
        let res = await this.fetch_paygroups(this.le_id);
        if (res.data.status) {
          this.paygroupList = res.data.payload.data;
        }
        this.paygroup_id = this.paygroupList.find(item => item.default == true);
        this.official.paygroup_id = this.paygroup_id.id;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* server call to get Department list for the current Legal Entity */
    async getDepartments() {
      try {
        let res = await this.fetch_departments(this.le_id);
        if (res.data.status) {
          this.departmentList = res.data.payload.data;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* server call to get Cost Centre list for the current Legal Entity */
    async getCostCenter() {
      try {
        let res = await this.fetch_cost_center(this.le_id);
        if (res.data.status) {
          this.costCenterList = res.data.payload.data;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /* server call to get Designation list for the current Legal Entity */
    async getDesignations() {
      try {
        let res = await this.fetch_designation(this.le_id);
        if (res.data.status) {
          this.designationList = res.data.payload.data;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /* server call to get Level list for the current Legal Entity */
    async getLevels() {
      try {
        let res = await this.fetch_level(this.le_id);

        if (res.data.status) {
          this.levelList = res.data.payload.data;
        }
      } catch (err) {

        this.toast = true;
        this.errmsg = err;
      }
    },
    /* server call to get Employee Categories list for the current Legal Entity */
    async getEmpCategoryList() {
      try {
        let res = await this.fetch_empCategories(this.le_id);
        if (res.data.status) {
          this.categoryList = res.data.payload.data;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    // dropdowns end
    // salary details code

    /* server call to calculate salary of the employee after selecting salary structure,
copmponents and entering ctc amount */

    async calculateSalary() {
      try {
        if (this.salary.ctc) {
          if(this.location_id){

          let res = await this.act_calculat_salary({
            salary_details: {
              salaryComponents: this.salary.master_salary_structure,
              ctc: this.salary.ctc
            },
            pfApplicable: this.pfesi.pf_enabled == "yes" ? true : false,
            esiApplicable: this.pfesi.entitled_esi =="yes" ? true : false,
            standardESIContribution: this.location_id.standardESIContribution,
            lwfApplicable: this.pfesi.lwf_applicable,
            le_id: this.le_id,
            loc_id: this.location_id ? this.location_id.id : null
          });
          if (res.data.status) {
            this.toast = false;
            this.errmsg = "";
            /* updating the salary table after getting response from server */
            if (res.data.payload.salary_detail.length) {
              let tempArray = [];
              Object.assign(tempArray, this.salaryTableData);
              this.salaryTableData.forEach((category, idx) => {
                tempArray[idx].total_monthly = 0;
                tempArray[idx].total_annual = 0;
                res.data.payload.salary_detail.forEach(element => {
                  let index = category.components.findIndex(
                    item => item.id === element.id
                  );
                  if (index > -1) {
                    element["transaction_type"] =
                      category.components[index].transaction_type;
                    tempArray[idx].components[index] = element;
                    tempArray[idx].total_monthly += Number(
                      tempArray[idx].components[index].monthly
                    ); // PL_3014
                    tempArray[idx].total_annual += Number(
                      tempArray[idx].components[index].annual
                    ); // PL_3014
                  }
                });
              });
              //console.log({ tempArray });
              this.salaryTableData = tempArray;
              this.salary.master_salary_structure =
                res.data.payload.salary_detail;
            }
          }
          }else{
             this.toast = true;
          this.errmsg = "Please select location!";
          }
        } else {
          this.toast = true;
          this.errmsg = "Please enter ctc amount!";
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to return Component objects to avoid redundent code and reduce the line of code*/

    getComponentObj(element, isExist) {
      try {
        return {
          id: element.id,
          name: element.name,
          abbreviation: element.abbreviation,
          calculationType: element.calculation_type,
          code: element.code,
          transaction_type: element.transaction_type,
          round_off_type: element.round_off_type, // PL_2358
          consider_esi_eligibility: element.consider_esi_eligibility,
          ctcSubSection: element.ctcSubSection,
          consider_esi_deduction: element.consider_esi_deduction,
          formula: element.calculation[0].formula,
          monthly: element.monthly
            ? element.monthly
            : element.calculation_type == "FLAT"
            ? parseFloat(
                (Number(element.calculation[0].formula) / 12).toFixed(2) // PL_3014
              )
            : 0,
          annual: element.annual
            ? element.annual
            : element.calculation_type == "FLAT"
            ? Number(element.calculation[0].formula) // PL_3014
            : 0,
          isEdited: false,
          isSelected: isExist
        };
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to return Category objects to avoid redundent code and reduce the line of code*/
    getComponentCategoryObj(element, category) {
      return {
        category: category,
        salary_component_type: element,
        components: [],
        total_monthly: 0,
        total_annual: 0
      };
    },

    /* categorising the salary components based on pay_type and ctcSubSection */

    fetchAllSalarycomponentsData(Obj, ssid) {
      try {
        //console.log({Obj});
        //console.log({ssid});
        //console.log("this.salaryStructureObj : ",this.salaryStructureObj);
        //console.log("this.salaryTableData : ",this.salaryTableData);
        //console.log("this.selectedTableData : ",this.selectedTableData);
        // let components = Obj.filter(component => component.selected == true || component.isSelected == true);
        // //console.log({components});
        this.salaryTableData = [];
        this.salary.master_salary_structure = [];

        Obj = Obj.filter(component =>
          component.selected == true && (component.salary_component_type == "FIXED" && component.part_of_ctc == true))
        let dataList = this.$route.query.id ? this.selectedTableData : Obj;
        if (dataList && dataList.length) {          
          this.isAllComponentSelected = true;
          let categoryArray = [];
          /* loop to make category list */
          dataList.forEach(element => {
            if (
              // element.pay_type !== "STATUTORY" &&
              element.ctcSubSection == "FixedGross"
            ) {
              if (categoryArray &&
                !categoryArray.some(item => item == element.ctcSubSection)
              ) {
                categoryArray.push(element.ctcSubSection);
              }
            }
            if (
              // element.pay_type !== "STATUTORY" &&
              element.ctcSubSection == "Variable"
            ) {
              if (categoryArray &&
                !categoryArray.some(item => item == element.ctcSubSection)
              ) {
                categoryArray.push(element.ctcSubSection);
              }
            }
            if (
              // element.pay_type == "STATUTORY" &&
              element.ctcSubSection == "NA"
            ) {
              if (categoryArray &&
                !categoryArray.some(item => item == element.ctcSubSection)
              ) {
                categoryArray.push(element.ctcSubSection);
              }
            }
          });
          categoryArray.forEach(element => {
            if (element == "FixedGross") {
              this.salaryTableData.push(
                this.getComponentCategoryObj(element, "Fixed Gross")
              );
            } else if (element == "Variable") {
              this.salaryTableData.push(
                this.getComponentCategoryObj(element, "Variable Salary")
              );
            } else {
              this.salaryTableData.push(
                this.getComponentCategoryObj(element, "Statutory")
              );
            }
          });
          /* loop to update categories with their respective components */
          dataList.forEach(element => {
            let isExist = true;
            if (this.selectedTableData && this.selectedTableData.length) {
              isExist = this.selectedTableData.some(
                item => item.id == element.id
              );
            }
            if (element.ctcSubSection == "FixedGross") {
              let index = this.salaryTableData.findIndex(
                item =>
                  item.salary_component_type === element.ctcSubSection
              );
              if (index > -1) {
                let compObj = this.$route.query.id ? element : this.getComponentObj(element, isExist);

                this.salaryTableData[index].components.push(compObj);
                this.salary.master_salary_structure.push(compObj);
              }
            }
            else if (element.ctcSubSection == "Variable") {
              let index = this.salaryTableData.findIndex(
                item =>
                  item.salary_component_type === element.ctcSubSection
              );
              if (index > -1) {
                let compObj = this.$route.query.id ? element : this.getComponentObj(element, isExist);

                this.salaryTableData[index].components.push(compObj);
                this.salary.master_salary_structure.push(compObj);
              }
            } else if (
              element.ctcSubSection == "NA"
              // element.pay_type == "STATUTORY"
            ) {
              let index = this.salaryTableData.findIndex(
                item =>
                  item.salary_component_type === element.ctcSubSection
              );
              if (index > -1) {
                let compObj = this.$route.query.id ? element : this.getComponentObj(element, isExist);

                this.salaryTableData[index].components.push(compObj);
                this.salary.master_salary_structure.push(compObj);
              }
            }
          });
            //console.log("this.salaryTableData : ",this.salaryTableData);
          this.salaryTableData.forEach((category, idx) => {
            this.salaryTableData[idx].total_monthly = 0;
            this.salaryTableData[idx].total_annual = 0;
            category.components.forEach(element => {
              this.salaryTableData[idx].total_monthly += Number(
                element.monthly
              ); // PL_3014
              this.salaryTableData[idx].total_annual += Number(element.annual); // PL_3014
            });
          });
        }

          //console.log("this.salaryTableData : ",this.salaryTableData);

        /* code block to update salary dtails table while editing */

        if (this.selectedTableData.length) {
          let arrayList = [];
          Object.assign(arrayList, this.salaryTableData);
          this.salaryTableData.forEach((category, idx) => {
            // Start PL_2289
            arrayList[idx].total_monthly = 0;
            arrayList[idx].total_annual = 0;
            // End PL_2289
            this.selectedTableData.forEach(element => {
              let index = category.components.findIndex(
                item => item.id === element.id
              );
              if (index > -1) {
                element.isEdited = false;
                element["transaction_type"] =
                  category.components[index].transaction_type;
                arrayList[idx].components[index] = element;
                arrayList[idx].total_monthly += Number(
                  arrayList[idx].components[index].monthly
                ); // PL_3014
                arrayList[idx].total_annual += Number(
                  arrayList[idx].components[index].annual
                ); // PL_3014
              }
            });
          });
          // this.salaryTableData = this.selectedTableData;
          //console.log("this.salaryTableData ", this.salaryTableData);

          // Start PL_2561
          let selectedComponents = [];
          this.selectedTableData.forEach(element => {
            this.salary.master_salary_structure.forEach(ele => {
              if (ele.id == element.id && ele.isSelected) {
                selectedComponents.push(element);
              }
            });
          });
          //console.log("this.salaryTableData ", this.salaryTableData);
          //console.log("this.selectedTableData ", this.selectedTableData);
          this.salary.master_salary_structure = selectedComponents;
          // End PL_2561
          if (dataList.length != this.selectedTableData.length) {
            this.isAllComponentSelected = false;
          }
        }
        this.salary.salary_structure_id = ssid;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /* function to calculate total annual amount(category wise) when user enters amount in annual input field of the components */
    calculateTotalAnnual(index, compIndex) {
      try {
        let sum = 0;
        let sumMonthly = 0;
        this.salaryTableData[index].components[compIndex].monthly = parseFloat(
          (
            Number(this.salaryTableData[index].components[compIndex].annual) /
            12
          ) // PL_3014
            .toFixed(2)
        );
        this.salaryTableData[index].components.forEach(element => {
          sum += Number(element.annual); // PL_3014
          sumMonthly += Number(element.monthly); // PL_3014
        });
        this.salaryTableData[index].total_annual = sum;
        this.salaryTableData[index].total_monthly = parseFloat(
          sumMonthly.toFixed(2)
        );
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to calculate total monthly amount(category wise) when user enters amount in monthly amount input of the components */
    calculateTotalMonthly(index, compIndex) {
      try {
        let sumMonthly = 0;
        let sum = 0;
        this.salaryTableData[index].components[compIndex].annual =
          Number(this.salaryTableData[index].components[compIndex].monthly) *
          12; // PL_3014
        this.salaryTableData[index].components.forEach(element => {
          sumMonthly += Number(element.monthly); // PL_3014
          sum += Number(element.annual); // PL_3014
        });
        this.salaryTableData[index].total_annual = sum;
        this.salaryTableData[index].total_monthly = sumMonthly;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to update the salary details if any component will be selected or unselected */
    onComponentSelect(component, isChecked, index, categoryIndex) {
      try {
        if (isChecked) {
          this.salary.master_salary_structure.push(component);
        } else {
          let idx = this.salary.master_salary_structure.findIndex(
            item => item.id == component.id
          );
          this.salary.master_salary_structure.splice(idx, 1);
          this.salaryTableData[categoryIndex].components[index].monthly = 0;
          this.salaryTableData[categoryIndex].components[index].annual = 0;
          this.salaryTableData.forEach((category, idx) => {
            this.salaryTableData[idx].total_monthly = 0;
            this.salaryTableData[idx].total_annual = 0;
            category.components.forEach(element => {
              this.salaryTableData[idx].total_monthly += Number(
                element.monthly
              ); // PL_3014
              this.salaryTableData[idx].total_annual += Number(element.annual); // PL_3014
            });
          });
        }
        let tempArr = [];
        this.salaryTableData.forEach(element => {
          tempArr.push(...element.components);
        });
        if (this.salary.master_salary_structure.length == tempArr.length) {
          this.isAllComponentSelected = true;
        } else {
          this.isAllComponentSelected = false;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to update salary details if select all checkbox is checked or unchecked*/

    onAllComponentSelect(event) {
      try {
        if (event) {
          this.salary.master_salary_structure = [];
          this.salaryTableData.forEach(element => {
            element.components.forEach(item => {
              item.isSelected = true;
            });
            this.salary.master_salary_structure.push(...element.components);
          });
        } else {
          this.salaryTableData.forEach(element => {
            element.components.forEach(item => {
              item.isSelected = false;
              item.annual = 0;
              item.monthly = 0;
            });
            element.total_monthly = 0;
            element.total_annual = 0;
          });
          this.salary.master_salary_structure = [];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /* Getting Salary Structure list for current LE from server */
    async fetchAllSalaryStructureData() {
      try {
        let res = await this.act_fetchAll(this.le_id);
        this.salarystructure = res.data.payload;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* Getting UDF list for current LE from server */
    async fetchUdf() {
      try {
        let res = await this.act_fetchUdf(this.le_id);
        this.udfData = [];
        if (res.data.status) {
          this.udfData = res.data.payload.data;
          this.filteredUdf = this.udfData
            .filter(item => item.criteria == null)
            .map(ele => {
              return {
                legal_entity_user_define_field_id: ele.id,
                criteria: ele.criteria,
                field_name: ele.name,
                value: "",
                editable_by_employee: ele.isEditableByEmployee
              };
            });
        }
      } catch (err) {
        this.toast = false;
        this.errmsg = err;
      }
    },

    /* Flitering UDFs based selected values(Location, Employee categories, Salary Bands, Grades, Department, Cost Centre)
     in Official information section */

    //  Start PL_2934
    filterUdf(criteria, value) {
      try {
        let obj = null;
        if (value) {
          obj = this.udfData.find(
            item =>
              item.criteria && item.criteria.value &&
              item.criteria.value.some(ele => ele.id == value.id)
          );
        }
        let index = this.filteredUdf.findIndex(y => y.criteria == criteria);
        if (obj && Object.keys(obj).length) {
          let udfObj = {
            legal_entity_user_define_field_id: obj.id,
            criteria: obj.criteria.type,
            field_name: obj.name,
            value: "",
            editable_by_employee: obj.isEditableByEmployee
          };
          if (index == -1) {
            this.filteredUdf.push(udfObj);
          } else {
            this.filteredUdf[index] = udfObj;
          }
        } else {
          if (
            index > -1 && this.filteredUdf &&
            this.filteredUdf.some(y => y.criteria == criteria)
          ) {
            this.filteredUdf.splice(index, 1);
          }
        }
      } catch (error) {
        this.toast = false;
        this.errmsg = error;
      }
    },

    /* setting PF values based on PF configuration for Current LE
     if Enable PF radio is selected as yes or no */

    // End PL_2934
    //  Start PL_2622
    onPFChange(value) {
      try {
        if (value == "no") {
          this.pfesi.pf_number = null;
          this.pf_wage=0;
          this.pfesi.uan_number = null;
          this.pfesi.nomniee_name = null;
          this.pfesi.nomniee_dob = null;
          this.pfesi.relationship = null;
          this.relationship = null;
          this.pfesi.pf_enrollment_date = null;
          this.employeecontributionrule = null;
          this.employercontributionrule = null;
          this.salaryTableData.forEach(element => {
             if(element.category== "Statutory"){

               element.components.forEach(item => {

               if(item.code=="EPF"){
                item.isSelected = false;
                item.monthly = 0;
                item.annual = 0;
                element.total_monthly=0;
                element.total_annual=0;
                element.total_monthly += Number(
                item.monthly
              );
              element.total_annual += Number(item.annual);

               }
          if(item.code=="ErPF"){
                item.isSelected = false;
                item.monthly = 0;
                item.annual = 0;
                element.total_monthly=0;
                element.total_annual=0;
                element.total_monthly += Number(
                item.monthly
              );
              element.total_annual += Number(item.annual);
              }
            });
             }

          });
        }
        if (value == "yes"){
             this.salaryTableData.forEach(element => {
             if(element.category== "Statutory"){

               element.components.forEach(item => {

               if(item.code=="EPF"){
                item.isSelected = true;
               }
               if(item.code=="ErPF"){
                item.isSelected = true;
               }

            });
             }

          });

        }

              let tempArr = [];
              this.salaryTableData.forEach(element => {
                tempArr.push(...element.components);
              });
              //console.log(tempArr.length);
              if (this.salary.master_salary_structure.length == tempArr.length) {
                this.isAllComponentSelected = true;
              } else {
                this.isAllComponentSelected = false;
              }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* setting ESI values based on selected location
     if Entitled to ESI radio is selected as yes or no */
    onESIChange(value) {
      if (value == "no") {
        this.pfesi.esi_number = null;
      }
    },
    /* setting PT values based on selected location
     if applicable to PT checkbox is checked */
    onPTChange(value) {
      this.checkboxPT = !this.checkboxPT
      try {
        if (value && this.location_id) {
          // PL_2669
          this.pt_deduction_frequency = this.deductionFrequencyOptions.find(
            item => item.id == this.location_id.pt_deduction_frequency
          );
          this.pfesi.pt_deduction_frequency = this.location_id.pt_deduction_frequency;
          this.pt_state_id = this.location_id.ptState;
          this.pfesi.pt_state_id = this.location_id.ptStateID;
        } else {
          this.pfesi.pt_state_id = null;
          this.pt_state_id = null;
          this.pt_deduction_frequency = null;
          this.pfesi.pt_deduction_frequency = null;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /* setting minimum wage values based on selected location
     if eligible for minimum wage checkbox is checked */
    onMinimumWageChange(value) {
      try {
        if (value && this.location_id) {
          // PL_2669
          if (this.location_id.industry_type) {
            this.minimum_wage_industry_type = this.industrytype.find(
              item => item.id == this.location_id.industry_type
            );
            this.pfesi.minimum_wage_industry_type = this
              .minimum_wage_industry_type
              ? this.minimum_wage_industry_type.id
              : null;
          }
          if (this.location_id.minimumWageZoneID) {
            this.minimum_wage_zone_id = this.location_id.MinimumWageZone;
            this.pfesi.minimum_wage_zone_id = this.location_id.minimumWageZoneID
              ? this.location_id.minimumWageZoneID
              : null;
            this.pfesi.minimum_wage_calculated_on = this.location_id.minimumWageSalaryType;
          }
        } else {
          this.minimum_wage_industry_type = null;
          this.pfesi.minimum_wage_industry_type = null;
          this.minimum_wage_zone_id = null;
          this.pfesi.minimum_wage_zone_id = null;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    // End PL_2622

    // store unsaved Employee Data
    async storeEmpData() {
      try {
        if (this.bank.same_acc_fbp) {
          this.bank.fbp.account_holder_name = this.bank.account_holder_name;
          this.bank.fbp.account_number = this.bank.account_number;
          this.bank.fbp.account_type = this.bank.account_type;
          this.bank.fbp.paymentType = this.bank.paymentType;
          this.bank.fbp.bank_name = this.bank.bank_name;
          this.bank.fbp.ifsc_code = this.bank.ifsc_code
            ? this.bank.ifsc_code
            : null;
          this.bank.fbp.branch_name = this.bank.branch_name;
          this.bank.fbp.bank_transfer_type = this.bank.bank_transfer_type;
          this.bank.fbp.micr_code = this.bank.micr_code;
          this.bank.fbp.upi = this.bank.upi;
          this.fbp_bank_id = this.payroll_bank_id;
        }

        // setting country id - 21/11/2019
        this.personal.permanent_address.countryID = this.country_id.id;
        this.personal.communication_address.countryID = this.comCountryID.id;
        this.personal.code = this.personal.code.trim();
        //  Start PL_2955
        this.personal.phoneNumber = this.personal.phoneNumber
          ? String(this.personal.phoneNumber).trim()
          : null;
        this.personal.pran_number = this.personal.pran_number
          ? String(this.personal.pran_number).trim()
          : null;
        this.personal.mobile_number = this.personal.mobile_number
          ? String(this.personal.mobile_number).trim()
          : null;
        this.personal.emergency_contact_number = this.personal
          .emergency_contact_number
          ? String(this.personal.emergency_contact_number).trim()
          : null;
        this.personal.adhar_number = this.personal.adhar_number
          ? String(this.personal.adhar_number).trim()
          : null;
        this.personal.permanent_address.pincode = this.personal
          .permanent_address.pincode
          ? String(this.personal.permanent_address.pincode).trim()
          : null;
        this.personal.permanent_address.phoneNumber = this.personal
          .permanent_address.phoneNumber
          ? String(this.personal.permanent_address.phoneNumber).trim()
          : null;
        this.personal.communication_address.pincode = this.personal
          .communication_address.pincode
          ? String(this.personal.communication_address.pincode).trim()
          : null;
        this.personal.communication_address.phoneNumber = this.personal
          .communication_address.phoneNumber
          ? String(this.personal.communication_address.phoneNumber).trim()
          : null;
        this.pfesi.pf_number = this.pfesi.pf_number
          ? String(this.pfesi.pf_number).trim()
          : null;
        this.pfesi.pf_wage = this.pfesi.pf_wage
          ? String(this.pfesi.pf_wage).trim()
          : null;
        this.pfesi.uan_number = this.pfesi.uan_number
          ? String(this.pfesi.uan_number).trim()
          : null;
        this.pfesi.esi_number = this.pfesi.esi_number
          ? String(this.pfesi.esi_number).trim()
          : null;
        this.bank.account_number = this.bank.account_number
          ? String(this.bank.account_number).trim()
          : null;
        this.bank.micr_code = this.bank.micr_code
          ? String(this.bank.micr_code).trim()
          : null;
        this.bank.addbank.account_number = this.bank.addbank.account_number
          ? String(this.bank.addbank.account_number).trim()
          : null;
        this.bank.addbank.micr_code = this.bank.addbank.micr_code
          ? String(this.bank.addbank.micr_code).trim()
          : null;
        this.bank.fbp.account_number = this.bank.fbp.account_number
          ? String(this.bank.fbp.account_number).trim()
          : null;
        this.bank.fbp.micr_code = this.bank.fbp.micr_code
          ? String(this.bank.fbp.micr_code).trim()
          : null;
        this.bank.addbank.credit = this.bank.addbank.credit
          ? String(this.bank.addbank.credit).trim()
          : null;
        // End PL_2955
        let obj = {
          personal: {
            ...this.personal,
            legal_entity_id: this.le_id,
            anniversary_date: null,
            pan_photo_url: null,
            adhar_photo_url: null,
            passport_number: null,
            passport_photo_url: null
          },
          official: {
            ...this.official,
            last_working_day: null,
            retirement_date: null,
            legal_entity_id: this.le_id
          },
          salary: {
            ...this.salary,
            send_payslips_automatically: true
          },
          pfesi: { ...this.pfesi },

          bank: { ...this.bank },
          udf: this.filteredUdf.filter(
            // PL_2934
            item => item.value != null && item.value != ""
          ),
          employeePreviousEmployer: {
            gratuity_details: this.gratuity_details
              .map(item => {
                return {
                  ...item,
                  slabFinancialYear:
                    new Date(item.slabFinancialYear).getFullYear() + "" // converting year into string
                };
              })
              .filter(item => item.slabAmount != null),
            leave_encashment: this.leave_encashment
              .map(item => {
                return {
                  ...item,
                  leaveFinancialYear:
                    new Date(item.leaveFinancialYear).getFullYear() + "" // converting year into string
                };
              })
              .filter(item => item.leaveAmount != null),
            lta_details: this.lta_details.filter(item => item.ltaAmount != null)
          },
          nonCTC: this.assignedComponentsList.map(item => {
            return {
              ...item,
              componentObj: null,
              status: this.getStatus(item)
            };
          })
        };        await this.act_s
        await this.act_storeUnsavedEmployeeData(obj);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* preparing request and calling post api to save the data */
    async save() {
      try {
        let finalDocumentsArray = [
          ...this.DocumentData.filter(item => item.location != null),
          ...this.ProfessionalDocumentData.filter(
            item => item.location != null
          ),
          ...this.EducationalDocumentsData.filter(item => item.location != null)
        ];
        if (this.$route.query.id) {
          this.filteredUdf.forEach(element => {
            // PL_2934
            element["employee_id"] = this.$route.query.id;
          });
        }
        /* copying the baknk details if the same aaccount for FBP checkbox is checked */
        if (this.bank.same_acc_fbp) {
          this.bank.fbp.account_holder_name = this.bank.account_holder_name;
          this.bank.fbp.account_number = this.bank.account_number;
          this.bank.fbp.account_type = this.bank.account_type;
          this.bank.fbp.paymentType = this.bank.paymentType;
          this.bank.fbp.bank_name = this.bank.bank_name;
          this.bank.fbp.ifsc_code = this.bank.ifsc_code
            ? this.bank.ifsc_code
            : null;
          this.bank.fbp.branch_name = this.bank.branch_name;
          this.bank.fbp.bank_transfer_type = this.bank.bank_transfer_type;
          this.bank.fbp.micr_code = this.bank.micr_code;
          this.bank.fbp.upi = this.bank.upi;
          this.fbp_bank_id = this.payroll_bank_id;
        }

        // setting country id - 21/11/2019
        this.personal.permanent_address.countryID = this.country_id.id;
        this.personal.communication_address.countryID = this.comCountryID.id;
        this.personal.code = this.personal.code.trim();
        //  Start PL_2955
        this.personal.phoneNumber = this.personal.phoneNumber
          ? String(this.personal.phoneNumber).trim()
          : null;
       // this.personal.permanent_address.stateName = this.personal.permanent_address.stateName ? String(this.personal.permanent_address.stateName) : null;
        this.personal.pran_number = this.personal.pran_number
          ? String(this.personal.pran_number).trim()
          : null;
        this.personal.mobile_number = this.personal.mobile_number
          ? String(this.personal.mobile_number).trim()
          : null;
        this.personal.emergency_contact_number = this.personal
          .emergency_contact_number
          ? String(this.personal.emergency_contact_number).trim()
          : null;
        this.personal.adhar_number = this.personal.adhar_number
          ? String(this.personal.adhar_number).trim()
          : null;
        this.personal.permanent_address.pincode = this.personal
          .permanent_address.pincode
          ? String(this.personal.permanent_address.pincode).trim()
          : null;
        this.personal.permanent_address.phoneNumber = this.personal
          .permanent_address.phoneNumber
          ? String(this.personal.permanent_address.phoneNumber).trim()
          : null;
        this.personal.communication_address.pincode = this.personal
          .communication_address.pincode
          ? String(this.personal.communication_address.pincode).trim()
          : null;
          this.personal.communication_address.cityName = this.personal.communication_address.cityName ? String(this.personal.communication_address.cityName) : null;
        this.personal.communication_address.stateName = this.personal.communication_address.stateName ? String(this.personal.communication_address.stateName) : null;
        this.personal.communication_address.phoneNumber = this.personal
          .communication_address.phoneNumber
          ? String(this.personal.communication_address.phoneNumber).trim()
          : null;
        this.pfesi.pf_number = this.pfesi.pf_number
          ? String(this.pfesi.pf_number).trim()
          : null;
        this.pfesi.pf_wage = this.pfesi.pf_wage
          ? String(this.pfesi.pf_wage).trim()
          : null;
        this.pfesi.uan_number = this.pfesi.uan_number
          ? String(this.pfesi.uan_number).trim()
          : null;
        this.pfesi.esi_number = this.pfesi.esi_number
          ? String(this.pfesi.esi_number).trim()
          : null;
        this.pfesi.employeecontributionrule = this.employeecontributionrule ? this.employeecontributionrule.id : null;
        this.pfesi.employercontributionrule = this.employercontributionrule ? this.employercontributionrule.id : null;
        this.bank.account_number = this.bank.account_number
          ? String(this.bank.account_number).trim()
          : null;
        this.bank.micr_code = this.bank.micr_code
          ? String(this.bank.micr_code).trim()
          : null;
        this.bank.addbank.account_number = this.bank.addbank.account_number
          ? String(this.bank.addbank.account_number).trim()
          : null;
        this.bank.addbank.micr_code = this.bank.addbank.micr_code
          ? String(this.bank.addbank.micr_code).trim()
          : null;
        this.bank.fbp.account_number = this.bank.fbp.account_number
          ? String(this.bank.fbp.account_number).trim()
          : null;
        this.bank.fbp.micr_code = this.bank.fbp.micr_code
          ? String(this.bank.fbp.micr_code).trim()
          : null;
        this.bank.addbank.credit = this.bank.addbank.credit
          ? String(this.bank.addbank.credit).trim()
          : null;
        // End PL_2955
        let obj = {
          personal: {
            ...this.personal,
            legal_entity_id: this.le_id,
            anniversary_date: null,
            pan_photo_url: null,
            adhar_photo_url: null,
            passport_number: null,
            passport_photo_url: null
          },
          official: {
            ...this.official,
            last_working_day: null,
            retirement_date: null,
            legal_entity_id: this.le_id
          },
          salary: {
            ...this.salary,
            send_payslips_automatically: true
          },
          pfesi: { ...this.pfesi },

          bank: { ...this.bank },
          udf: this.filteredUdf.filter(
            // PL_2934
            item => item.value != null && item.value != ""
          ),
          employeePreviousEmployer: {
            gratuity_details: this.gratuity_details
              .map(item => {
                return {
                  ...item,
                  slabFinancialYear:
                    new Date(item.slabFinancialYear).getFullYear() + "" // converting year into string
                };
              })
              .filter(item => item.slabAmount != null),
            leave_encashment: this.leave_encashment
              .map(item => {
                return {
                  ...item,
                  leaveFinancialYear:
                    new Date(item.leaveFinancialYear).getFullYear() + "" // converting year into string
                };
              })
              .filter(item => item.leaveAmount != null),
            lta_details: this.lta_details.filter(item => item.ltaAmount != null)
          },
          documents: finalDocumentsArray,
          nonCTC: this.assignedComponentsList.map(item => {
            return {
              ...item,
              componentObj: null,
              status: this.getStatus(item)
            };
          })
        };
        obj.pfesi.pf_enabled = obj.pfesi.pf_enabled == "yes" ? true:false,
        obj.pfesi.entitled_esi = obj.pfesi.entitled_esi == "yes" ? true:false,
        obj.personal.name = this.personal.first_name;
        this.$root._data.isSaving = true;
        if (this.$route.query.id) {
          obj["id"] = this.$route.query.id;
          obj.personal["id"] = this.$route.query.id;
          obj.salary["employee_id"] = this.$route.query.id;

          let res = await this.act_update(obj);
          if (res.data.status) {
            this.showSuccessMsg = true;
            this.responseMsg = res.data.message;
          }
        } else {
          let res = await this.act_create(obj);
          if (res.data.status) {
            this.showSuccessMsg = true;
            this.responseMsg = res.data.message;
          }
        }
        await this.act_storeUnsavedEmployeeData(null);
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    submitForm(text) {
      this.navigation = text;
      if (this.btnText == "Next" && this.navigation == "navigate") {
        this.$router.push({
          path: `/payroll/run/${this.$route.params.entity_index}/exits`
        });
      } else {
        this.$validator.validateAll().then(result => {
          if (result) {
            if (this.salary.ctc) {
              /* calculating total and checking if the ctc is matching with total or not*/
              let total = 0;
              this.salary.master_salary_structure = [];
              this.salaryTableData.forEach(element => {
                total = total + element.total_annual;
                this.salary.master_salary_structure.push(...element.components);
              });
              if (this.salary.ctc == total) {
                this.save();
              } else {
                this.toast = true;
                this.errmsg =
                  `Difference of Rs. ${this.salary.ctc - total} between CTC and total of annual of all selected salary components. Please check the value of selected components.`;
              }
            }
          } else {
            // to navigate to error fields(PL- 1872) - 28/11/2019
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .focus();
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
              });
            this.toast = true;
            this.errmsg = "Please fill mandatory fields!";
          }
        });
      }
    },

    // salary details code end

    // bank details code

    paymentmode(val) {
      this.paymentType = val;
    },

    // bank details code end

    backfrompopup() {
      this.showSuccessMsg = false;
      this.showErrorPopup = false;
      if (this.isJoinComponent) {
        this.refresh();
        this.resetForm();
        if (this.navigation == "navigate") {
          /* navigation to exits page in payroll wizard */
          this.$router.push({
            path: `/payroll/run/${this.$route.params.entity_index}/exits`
          });
        }
      } else {
        /* navigation to Employee dashboard */
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/employeeDashboard`
        });
      }
    },
    async goBackToDashboardPage() {
      if (this.btnText == "Next") {
        /* navigation to paygroups page in payroll wizard  */
        this.$router.push({
          path: `/payroll/run/${this.$route.params.entity_index}/paygroups`
        });
      } else {
        /* navigation to Employee dashboard */
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/employeeDashboard`
        });
      }
      await this.act_storeUnsavedEmployeeData(null);
    },
    /* To copy the address details if same as personal address checkbox is checked */
    mapAddress(val) {
      try {
        if (val) {
          this.comCountryID = this.country_id;
          this.comStateID = this.state_id;
          this.comCityID = this.city_id;
          this.communicationAddressDisable=true;
          // Start UAT_184
          this.personal.communication_address = this.personal.permanent_address;
          this.personal.communication_address.isSameAsPermanent = val;
          // End UAT_184
        } else {
          this.comCountryID = {};
          this.comStateID = {};
          this.comCityID = {};
          this.communicationAddressDisable=false;
          this.personal.communication_address = {
            isSameAsPermanent: false,
            addressLineOne: null,
            addressLineTwo: null,
            stateName: null,
            cityName: null,
            cityID: null,
            stateID: null,
            countryID: null,
            pincode: null,
            email: null,
            phoneNumber: null
          };
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* to reset form and validation */
    resetForm() {
      try {
        this.$validator.reset();
        this.state_id = null;
        this.city_id = null;
        this.country_id = this.countriesListArray[0]
          ? this.countriesListArray[0]
          : null;
        this.phone_number = null;
        this.comCountryID = this.countriesListArray[0]
          ? this.countriesListArray[0]
          : null;
        this.comCityID = null;
        this.salaryTableData = [];
        this.salaryStructureObj = null;
        this.assignedComponentsList = [];
        this.comStateID = {};
        this.paygroup_id = null;
        this.grade_id = null;
        this.band_id = null;
        this.location_id = null;
        // start PL_1976
        this.disability = null;
        this.vasectomy = null;
        this.relationship = null;
        // end PL_1976
        this.employeesubcategoryList_id = null;
        this.payroll_bank_id = null;
        this.other_bank_id = null;
        this.fbp_bank_id = null;
        this.componentsList = [];
        this.department_id = null;
        this.lta_details = [
          {
            blockYear: null,
            ltaFinancialYear: null,
            ltaCompanyName: null,
            ltaAmount: null
          }
        ];
        this.leave_encashment = [
          {
            leaveFinancialYear: null,
            leaveCompanyName: null,
            leaveAmount: null
          }
        ];
        this.gratuity_details = [
          {
            slabFinancialYear: null,
            slabCompanyName: null,
            slabAmount: null
          }
        ];
        this.designation_id = null;
        this.level_id = null;
        this.cost_center_id = null;
        (this.personal = {
          first_name: null,
          last_name: null,
          father_name : null,
          mother_name : null,
          username: null,
          marital_status: null,
          photo_url: null,
          code: null,
          name: null,
          dob: null,
          email_id: null,
          phoneNumber: null,
          mobile_number: null,
          pran_number: null,
          pan_number: null,
          adhar_number: null,
          emergency_contact_name: null,
          emergency_contact_number: null,
          permanent_address: {
            addressLineOne: null,
            addressLineTwo: null,
            countryID: null,
            stateID: null,
            cityID: null,
            stateName: null,
            cityName: null,
            pincode: null,
            phoneNumber: null,
            email: null
          },
          communication_address: {
            isSameAsPermanent: false,
            addressLineOne: null,
            addressLineTwo: null,
            countryID: null,
            stateID: null,
            cityID: null,
            stateName: null,
            cityName: null,
            pincode: null,
            email: null,
            phoneNumber: null
          },
          gender: "male",
          employee_tax_status: "resident",
          metro: true,
          enable_fbp_ess: false,
          // is_ess_enable: false
        }),
          (this.skill = "");
        (this.official = {
          reporting_manager_id: null,
          is_reporting_manager: false,
          band_id: null,
          date_of_joining: null,
          official_email_id: null,
          category_data_json: null,
          skill: null,
          based_location_id: null,
          grade_id: null,
          department_id: null,
          designation_id: null,
          level_id: null,
          cost_center_id: null,
          paygroup_id: null,
          disability: null,
          vasectomy: null,
          employment_type:null,
        }),
          (this.salary = {
            ctc: null,
            salary_structure_id: null,
            exempt_for_it_deduction_first_month: false,
            master_salary_structure: []
          }),
          // PL-1847, 20/11/2019
          (this.pfesi = {
            pf_enabled: "no",
            uan_number: null,
            pf_number: null,
            pf_wage:0,
            pf_enrollment_date: null, // PL_2355
            nomniee_name: null,
            employeecontributionrule: null,
            employercontributionrule: null,
            nomniee_dob: null, // PL_2355
            entitled_esi: "no",
            minimum_wage_calculated_on: "BDA",
            relationship: null, // PL_2355
            esi_number: null,
            lwf_applicable: false,
            minimum_wage_eligible: false,
            pt_applicable: false,
            pt_state_id: null,
            pt_deduction_frequency: null, // PL_2355
            minimum_wage_industry_type: null, //PL_2314
            minimum_wage_zone_id: null, //PL_2314,
            pf_wage:0
          }),
          (this.bank = {
            same_acc_fbp: true,
            account_holder_name: null,
            account_number: null,
            account_type: null,
            paymentType: "Cash", // PL_2908
            bank_name: null,
            ifsc_code: null,
            branch_name: null,
            bank_transfer_type: null,
            micr_code: null,
            upi: null,
            fbp: {
              account_holder_name: null,
              account_number: null,
              account_type: null,
              bank_name: null,
              ifsc_code: null,
              branch_name: null,
              bank_transfer_type: null,
              micr_code: null,
              upi: null
            },
            addbank: {
              account_holder_name: null,
              account_number: null,
              account_type: null,
              bank_name: null,
              ifsc_code: null,
              branch_name: null,
              bank_transfer_type: null,
              micr_code: null,
              credit: null
            }
          });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** On PT State Dropdown click */
    onPtStateChange(value) {
      try {
        if (value && value.rule && value.rule.frequency) {
          switch (value.rule.frequency) {
            case 1:
              this.pt_deduction_frequency = this.deductionFrequencyOptions[0];
              break;
            case 3:
              this.pt_deduction_frequency = this.deductionFrequencyOptions[1];
              break;
            case 6:
              this.pt_deduction_frequency = this.deductionFrequencyOptions[2];
              break;
            case 12:
              this.pt_deduction_frequency = this.deductionFrequencyOptions[3];
              break;
            default:
              break;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** To clear the selected employee data */
    clearEmployee() {
      this.official.reporting_manager_id = null;
      this.managerName = null;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
@import "@/scss/_variables.scss";
.radio-container {
  display: flex;
  flex-direction: column;
  margin: 0px 0px 20px 0px;
  color: #404040;
  font-size: $font-size-small;
  *:nth-child(n) {
    margin-bottom: 10px;
  }
}
.Information-message {
  width: 149px;
  height: 18px;
  margin: 20px,;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.Rectangle {
  margin: -20px;
  width: 340px;
  height: 30px;
  border-radius: 4px;
  background-color: #e24c4b;
  display: flex;
  align-items: center;
}
.marginright{
  align-items:flex-end;
}
.custom-container {
  display: flex;
  align-items: flex-end;
  cursor: pointer;
  .img {
    height: 18px;
    width: 16px;
    object-fit: contain;
  }
  .text {
    font-size: 14px;
    font-weight: 600;
    color: $color-secondary;
    margin-left: 8px;
  }
}
.newaccountdetails {
  font-weight: bold;
  font-size: 20px;
  color: #555;
  padding: 15px 0px;
}
.radio-btn {
  display: flex;
}
.form-pf-esi {
  *:nth-child(n) {
    margin-bottom: 15px;
  }
}
.main-div {
  margin-bottom: 500px;
}
.label {
  width: 100%;
  height: 15px;
  font-size: 12px;
  color: #404040;
}
.top-bar {
  height: 64px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 0 32px;
  img {
    cursor: pointer;
    margin-right: 24px;
    width: 10px;
    height: 16px;
  }
}
.noUdfData {
  height: 22px;
  font-size: 18px;
  justify-content: center;
  display: flex;
  color: #858585;
  margin-top: 60px;
}
.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}
.heading {
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  padding-right: 10px;
}

.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.refresh-icon {
  cursor: pointer;
  float: right;
  padding-right: 20px;
}
.lock-list {
  margin-top: 2%;
  display: flex;
  span {
    margin-top: 2px;
  }
}
.main-div {
  margin-bottom: 120px;
}
.datePicker {
  margin-bottom: 5px !important;
}
.add-new {
  color: $color-primary;
  text-decoration: underline;
  font-size: $font-size-small;
  cursor: pointer;
  float: left;
}
.link {
  cursor: pointer;
}

.deleteButton{
  position: relative;
}

.delecteIcon {
  vertical-align: middle;
  position: absolute;
  bottom: 5px;
  // line-height: 30px;
  height: 30px;
  cursor: pointer;
  padding-left: 25px;
}

.datatable-outer-container {
  width: 100%;
  table.datatable {
    width: 100%;
    border-collapse: collapse;
    margin: 0 auto;
    font-family: Montserrat;
    margin-bottom: 4px;
    //   table-layout: fixed;

    .header-row {
      background-color: white;
      height: 54px;
      th {
        background-color: #f0f1f5;
        border-bottom: 0px solid #34c0be;
        padding: 6px 8px;
        //   text-align: center;
      }
    }
    .inactiveCols {
      opacity: 0.03;
      background-color: #a2a1a1;
    }
    // for datatable2
    .Editdeleteheader {
      background-color: #ffffff;
      box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);

      th {
        // border-right: 1px solid #ececec;
        padding: 0 8px;
        // display: flex;
        span {
          border-right: 1px solid #ececec;
          padding: 0px 18px 0px 15px;
          display: inline-block;
          vertical-align: middle;
          &:first-child {
            padding: 10px 10px 7px 10px;
          }
        }
        &:last-of-type {
          text-align: right;
          span {
            border-right: none;
            font-weight: 400;
            font-style: italic;
            position: relative;
            //    display: block;
            i {
              position: absolute;
              right: 10px;
              top: 2px;
            }
          }
        }
      }
    }
    .record-row {
      height: 54px;
      border-bottom: 0px solid #d8d8d8;
      //   text-align: center;
      &:nth-child(odd) {
        background-color: #f5f6fa;
      }
      &.selectedRecord {
        background-color: #e9f9f8;
        opacity: 0.9;
      }

      td {
        padding: 12px 8px;
        color: #000000;
      }

      .action-img {
        display: flex;
        cursor: pointer;
        opacity: 0.1;
      }

      &:hover {
        .action-img {
          opacity: 1;
        }
      }
    }
  }
}

.attach_file {
  width: 35px;
  text-align: center;
  padding: 7px 14px;
  height: 35px;
}
label.fileLabel input[type="file"] {
  opacity: 0;
  width: 0px;
  height: 0px;
  position: absolute;
  pointer-events: none;
}
label.fileLabel {
  color: #646464;
  text-decoration: underline;
  cursor: pointer;
  img {
    width: 20px;
  }
  .attachment {
    width: 20px;
  }
  .plus-icon {
    width: 25px;
    visibility: hidden;
  }
}

.custom-grid {
  display: grid;
  grid-template-columns: 20% 20%;
  grid-row-gap: 15px;
  grid-column-gap: 20px;
}

.business {
  width: 100%;
  height: 100%;
}
.addflexispace {
  display: flex;
}

.custom-input {
  border-radius: 4px;
  border: 1px solid #dadada;
  padding: 10px;
  width: 100%;
  max-width: 300px;
  height: 35px;
  -webkit-transition: ease-in-out, width 0.35s ease-in-out;
  transition: ease-in-out, width 0.35s ease-in-out;
  :focus {
    border: 1px solid #34c0be;
  }
}
.addPersonalDoc {
  float: left;
  margin-right: 20px;
}
.addNewDocument {
  padding: 5px !important;
  font-weight: normal !important;
}

// Start PL_2507
table.salaryDetails {
  border-collapse: collapse;
  width: 100%;
  thead {
    background: #f0f1f5;
    tr {
      th {
        padding: 20px 10px;
      }
    }
  }
  tbody {
    tr {
      td {
        padding: 20px 10px;
        color: #000000;
        opacity: 0.68;
        font-weight: 500;
      }
    }
    &:nth-child(odd) {
      background-color: #f0f1f5;
    }
  }
}
//  End PL_2507 
</style>
